<!-- 第三部销售报价单编辑 -->
<template>
    <div class="business-content-main bj-edit" v-loading="searchApParams._visible" element-loading-spinner="none">
        <div class="bread-nav">
            <el-button size="small" icon="el-icon-back" class="search-btn btn-primary" @click="goback()"></el-button>
            <el-button size="small" class="search-btn btn-primary" @click="showSearch()" tabindex="-1" v-if="submitData.CreatorType == 0 && !dataReadonly"
                >搜索配件(F2)</el-button
            >
            <el-button size="small" class="search-btn btn-primary" @click="showAPMsgDialog()" tabindex="-1" v-if="!dataReadonly">查看配件信息(F3)</el-button>
            <el-button class="search-btn btn-primary" title="报价历史" size="small" @click.stop="showHistories()" v-if="!dataReadonly">报价历史(F4) </el-button>
            <el-button title="销售历史" size="small" @click.stop="showHistoryDialog()" class="search-btn btn-primary" v-if="!dataReadonly">销售历史(F5) </el-button>
            <el-button title="采购历史" size="small" @click.stop="showPurHistories()" class="search-btn btn-primary" v-if="!dataReadonly">采购历史(F6) </el-button>
            <el-button size="small" class="search-btn btn-primary" @click="addCustomer(1)" v-if="!dataReadonly && permission.addCustomer && !dataReadonly"
                >{{ permission.addCustomer }} (F9)</el-button
            >
            <el-button
                size="small"
                class="search-btn btn-primary"
                @click="addCustomer(2)"
                v-if="!dataReadonly && permission.editCustomer && submitData.EntpCusId && !dataReadonly"
                >{{ permission.editCustomer }} (F10)
            </el-button>
            <el-button size="small" icon="el-icon-plus" class="search-btn btn-primary" @click.stop="showAddAPDialog" v-if="!dataReadonly">新增配件商品</el-button>
            <el-button size="small" class="search-btn btn-primary" @click.stop="submitForm()" v-if="!dataReadonly" :disabled="saving">提交报价(F12)</el-button>
            <!-- <el-button size="small" class="search-btn btn-primary" @click.stop="submitForm(type, 1)" v-if="permission.submit" :disabled="saving"
                >{{ permission.submit }}(F12)</el-button
            > -->
        </div>
        <div :class="showOrderMsg ? 'section-title' : 'section-title section-magin'">
            <div>
                <span>订单信息 {{ submitData.QCode ? '【' + submitData.QCode + '】' : '' }}</span>
                <span v-show="!showOrderMsg && submitData.EntpCusName">&nbsp;&nbsp;&nbsp;&nbsp;客户：{{ submitData.EntpCusName }}</span>
                <span style="margin-left: 5px; font-weight: 500"> 【 商品总数：{{ allNum }} &nbsp;&nbsp; 报价总额：{{ allMoney }} 】 </span>
            </div>
            <div class="img-e-op" @click="showMsg" v-show="!showOrderMsg">
                <img src="../../../assets/images/down-e.png" />
            </div>
            <div class="img-e-op" @click="hideMsg" v-show="showOrderMsg">
                <img src="../../../assets/images/up-e.png" />
            </div>
            <span v-if="submitData.WarehouseName" class="wNameTip"
                >出仓仓库：<i>{{ submitData.WarehouseName }}</i></span
            >
        </div>
        <div class="quotation-order-infoes" v-show="showOrderMsg">
            <el-form ref="form" label-width="80px" style="width: 100%; padding-right: 10px; padding-left: 10px" :rules="rules">
                <el-row :gutter="20">
                    <el-col :span="6"
                        ><div class="grid-content bg-purple">
                            <el-form-item label="选择客户" prop="EntpCusId">
                                <el-select
                                    ref="cusselect"
                                    style="width: 100%"
                                    size="small"
                                    :disabled="dataReadonly"
                                    v-model="submitData.EntpCusId"
                                    filterable
                                    clearable
                                    remote
                                    @change="customerChange($event)"
                                    @visible-change="customerVisibleChange($event)"
                                    :remote-method="searchCustomer"
                                    v-select-scroll-more="searchCustomLoad"
                                    reserve-keyword
                                    placeholder="选择客户"
                                >
                                    <el-option
                                        v-for="optionItem in customerList"
                                        :key="optionItem.EntpCusId"
                                        :data-msg="optionItem"
                                        :label="optionItem.EntpCusName"
                                        :value="optionItem.EntpCusId"
                                    ></el-option>
                                </el-select>
                            </el-form-item></div
                    ></el-col>
                    <el-col :span="6"
                        ><div class="grid-content bg-purple">
                            <el-form-item label="出仓仓库" prop="WarehouseId" style="width: 100%">
                                <el-input
                                    size="small"
                                    v-if="dataReadonly"
                                    :title="submitData.WarehouseName"
                                    v-model="submitData.WarehouseName"
                                    style="width: 100%"
                                    :disabled="true"
                                ></el-input>
                                <el-select
                                    v-else
                                    size="small"
                                    :disabled="dataReadonly"
                                    style="width: 100%"
                                    v-model="submitData.WarehouseId"
                                    placeholder="请选择"
                                    filterable
                                    clearable
                                    @visible-change="warehouseVisibleChange($event)"
                                    @change="warehouseChange"
                                >
                                    <el-option v-for="item in warehouseList" :key="item.WarehouseId" :label="item.WarehouseName" :value="item.WarehouseId">
                                        <span style="float: left">{{ item.WarehouseName }}</span>
                                        <span v-if="item.Type == 1" style="float: right; color: #8492a6; font-size: 13px">（前置仓）</span>
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </div></el-col
                    >
                    <el-col :span="6"
                        ><div class="grid-content bg-purple">
                            <el-form-item label="运费" prop="PriceSumShip">
                                <el-input
                                    min="0"
                                    size="small"
                                    style="width: 100%"
                                    type="number"
                                    step="0.01"
                                    :disabled="dataReadonly"
                                    v-model.trim="submitData.PriceSumShip"
                                ></el-input>
                            </el-form-item></div
                    ></el-col>
                    <el-col :span="6"
                        ><div class="grid-content bg-purple">
                            <el-form-item label="报价日期">
                                <el-date-picker
                                    size="small"
                                    style="width: 100%"
                                    :disabled="dataReadonly"
                                    value-format="yyyy-MM-dd"
                                    v-model="submitData.QTime"
                                    type="date"
                                ></el-date-picker>
                            </el-form-item></div
                    ></el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="6">
                        <div class="grid-content bg-purple">
                            <el-form-item label="期限日期">
                                <el-date-picker
                                    size="small"
                                    style="width: 100%"
                                    :disabled="dataReadonly"
                                    value-format="yyyy-MM-dd"
                                    v-model="submitData.NeedTime"
                                    type="date"
                                ></el-date-picker>
                            </el-form-item></div
                    ></el-col>
                    <el-col :span="6"
                        ><div class="grid-content bg-purple">
                            <el-form-item label="询价日期">
                                <el-date-picker
                                    size="small"
                                    style="width: 100%"
                                    :disabled="dataReadonly"
                                    value-format="yyyy-MM-dd"
                                    v-model="submitData.ITime"
                                    type="date"
                                ></el-date-picker>
                            </el-form-item></div
                    ></el-col>
                    <el-col :span="12"
                        ><div class="grid-content bg-purple">
                            <el-form-item label="客户要求" style="width: 100%">
                                <el-input size="small" :disabled="dataReadonly" v-model.trim="submitData.Remark"></el-input>
                            </el-form-item></div
                    ></el-col>
                </el-row>
            </el-form>
        </div>
        <div :class="showResultMsg ? 'section-title' : 'section-title section-magin'" @click="hideMsg" v-if="!dataReadonly">
            <div>
                <span>搜索配件结果</span>
                <span style="margin-left: 10px; font-size: 14px">{{ tableDataLength > 0 ? '(结果数：' + tableDataLength + ')' : '' }} </span>
                <el-link style="width: 120px" v-show="tableDataLength > 0" type="primary" @click="chooseAllAPsHandle">全部加入订单明细</el-link>
            </div>
            <div class="flex">
                <el-button icon="el-icon-refresh" type="primary" class="search-set-btn" @click="refreshResult()"></el-button>
                <el-button v-if="isCanTBSet" icon="el-icon-setting" type="primary" class="search-set-btn" @click="showTableSetDialog()"></el-button>
                <div class="img-e-op" @click="showResultFunc" v-show="!showResultMsg">
                    <img src="../../../assets/images/down-e.png" />
                </div>
                <div class="img-e-op" @click="hideResultFunc" v-show="showResultMsg">
                    <img src="../../../assets/images/up-e.png" />
                </div>
            </div>
        </div>
        <div @click="hideMsg" v-show="showResultMsg" class="search-in-order" style="margin-bottom: 5px">
            <ux-grid
                ref="multipleTable"
                border=""
                height="336px"
                style="width: 100%"
                @cell-dblclick="dblChooseAps"
                @table-body-scroll="tableLoad"
                highlight-current-row
                show-overflow
                :data="tableData"
                v-loading="searchData.page == 1 ? searchLoading : false"
                :row-class-name="tableRowClassName"
                @row-click="rowClick"
                empty-text=""
                @sort-change="sortChange"
            >
                <ux-table-column
                    v-if="columnShowSets.APCode.IsShow"
                    width="180px"
                    :title="columnShowSets.APCode.ColumnName"
                    field="APCode"
                    key="APCode"
                    sortable
                    remote-sort
                    resizable
                    header-align
                >
                    <template slot-scope="scope">
                        <el-button v-if="scope.row.MainImage" style="padding: 0" icon="el-icon-picture" type="text"></el-button>
                        <i v-if="scope.row.IsSelected" class="out-active">{{ scope.row.APCode }} </i>
                        <i v-else>{{ scope.row.APCode }} </i>
                    </template></ux-table-column
                >
                <ux-table-column
                    v-if="columnShowSets.GoodCode.IsShow"
                    :width="columnShowSets.GoodCode.Width > 0 ? columnShowSets.GoodCode.Width + 'px' : '180px'"
                    :title="columnShowSets.GoodCode.ColumnName"
                    field="GoodCode"
                    key="GoodCode"
                    sortable
                    remote-sort
                    resizable
                    header-align
                >
                    <template slot-scope="scope">
                        <i v-if="scope.row.IsSelected" class="out-active">{{ scope.row.GoodCode }} </i>
                        <i v-else>{{ scope.row.GoodCode }} </i>
                    </template>
                </ux-table-column>
                <ux-table-column
                    v-if="columnShowSets.GoodName.IsShow"
                    :width="columnShowSets.GoodName.Width > 0 ? columnShowSets.GoodName.Width + 'px' : '150px'"
                    :title="columnShowSets.GoodName.ColumnName"
                    field="GoodName"
                    key="GoodName"
                    sortable
                    remote-sort
                    resizable
                    header-align
                >
                    <template slot-scope="scope">
                        <i v-if="scope.row.IsSelected" class="out-active">{{ scope.row.GoodName }} </i>
                        <i v-else>{{ scope.row.GoodName }} </i>
                    </template>
                </ux-table-column>
                <ux-table-column
                    v-if="columnShowSets.AutoSerise.IsShow"
                    :width="columnShowSets.AutoSerise.Width > 0 ? columnShowSets.AutoSerise.Width + 'px' : '200px'"
                    :title="columnShowSets.AutoSerise.ColumnName"
                    field="AutoSerise"
                    key="AutoSerise"
                    sortable
                    remote-sort
                    header-align
                >
                    <template v-slot="{ row }">
                        <el-tooltip placement="top">
                            <div slot="content" v-html="$options.filters.AutoSeriseTextSplit(row.AutoSerise)"></div>
                            <div class="tooltip-div">{{ row.AutoSerise }}</div>
                        </el-tooltip>
                    </template>
                </ux-table-column>
                <ux-table-column
                    v-if="columnShowSets.GeneralModels.IsShow"
                    :width="columnShowSets.GeneralModels.Width > 0 ? columnShowSets.GeneralModels.Width + 'px' : '200px'"
                    :title="columnShowSets.GeneralModels.ColumnName"
                    field="GeneralModels"
                    key="GeneralModels"
                    sortable
                    remote-sort
                    header-align
                >
                    <template v-slot="{ row }">
                        <el-tooltip placement="top">
                            <div slot="content" v-html="$options.filters.AutoSeriseTextSplit(row.GeneralModels)"></div>
                            <div class="tooltip-div">{{ row.GeneralModels }}</div>
                        </el-tooltip>
                    </template>
                </ux-table-column>
                <ux-table-column
                    v-if="columnShowSets.Unit.IsShow"
                    :width="columnShowSets.Unit.Width > 0 ? columnShowSets.Unit.Width + 'px' : '60px'"
                    :title="columnShowSets.Unit.ColumnName"
                    field="Unit"
                    key="Unit"
                    resizable
                    header-align
                ></ux-table-column>
                <ux-table-column
                    v-if="columnShowSets.Size.IsShow"
                    :width="columnShowSets.Size.Width > 0 ? columnShowSets.Size.Width + 'px' : '140px'"
                    :title="columnShowSets.Size.ColumnName"
                    field="Size"
                    key="Size"
                    resizable
                    header-align
                ></ux-table-column>
                <ux-table-column
                    v-if="columnShowSets.Origin.IsShow"
                    :width="columnShowSets.Origin.Width > 0 ? columnShowSets.Origin.Width + 'px' : '120px'"
                    :title="columnShowSets.Origin.ColumnName"
                    field="Origin"
                    key="Origin"
                    resizable
                    sortable
                    header-align
                ></ux-table-column>
                <ux-table-column
                    v-if="columnShowSets.CostPrice.IsShow"
                    :width="columnShowSets.CostPrice.Width > 0 ? columnShowSets.CostPrice.Width + 'px' : '110px'"
                    :title="columnShowSets.CostPrice.ColumnName"
                    field="CostPrice"
                    key="CostPrice"
                    sortable
                    remote-sort
                    resizable
                    header-align
                >
                </ux-table-column>
                <ux-table-column
                    v-if="columnShowSets.Price.IsShow"
                    :width="columnShowSets.Price.Width > 0 ? columnShowSets.Price.Width + 'px' : '110px'"
                    :title="columnShowSets.Price.ColumnName"
                    field="Price"
                    key="Price"
                    sortable
                    remote-sort
                    resizable
                    header-align
                >
                </ux-table-column>
                <ux-table-column
                    v-if="columnShowSets.MarketPrice.IsShow"
                    :width="columnShowSets.MarketPrice.Width > 0 ? columnShowSets.MarketPrice.Width + 'px' : '110px'"
                    :title="columnShowSets.MarketPrice.ColumnName"
                    field="MarketPrice"
                    key="MarketPrice"
                    sortable
                    remote-sort
                    resizable
                    header-align
                ></ux-table-column>
                <ux-table-column
                    v-if="columnShowSets.Inventory.IsShow"
                    :width="columnShowSets.Inventory.Width > 0 ? columnShowSets.Inventory.Width + 'px' : '80px'"
                    :title="columnShowSets.Inventory.ColumnName"
                    field="Inventory"
                    key="Inventory"
                    sortable
                    remote-sort
                    resizable
                    header-align
                >
                    <template v-slot="{ row }">
                        <span class="inven-active">{{ submitData.WarehouseId ? row.StorageInventory : row.Inventory }}</span>
                    </template>
                </ux-table-column>
                <ux-table-column
                    v-if="columnShowSets.Remaining.IsShow"
                    :width="columnShowSets.Remaining.Width > 0 ? columnShowSets.Remaining.Width + 'px' : '80px'"
                    :title="columnShowSets.Remaining.ColumnName"
                    field="Remaining"
                    key="Remaining"
                    resizable
                    header-align
                >
                    <template v-slot="{ row }">
                        <span class="out-active">
                            {{ row.StorageInventory + (isAddWaitIn ? row.POrderWaitInQuantity : 0) - row.OrderWaitOutQuantity }}
                        </span>
                    </template>
                </ux-table-column>
                <ux-table-column
                    v-if="columnShowSets.OrderWaitOutQuantity.IsShow"
                    :width="columnShowSets.OrderWaitOutQuantity.Width > 0 ? columnShowSets.OrderWaitOutQuantity.Width + 'px' : '80px'"
                    :title="columnShowSets.OrderWaitOutQuantity.ColumnName"
                    field="OrderWaitOutQuantity"
                    key="OrderWaitOutQuantity"
                    resizable
                    header-align
                >
                    <template v-slot="{ row }">
                        <el-button v-if="row.LoadSpaceInvent" icon="el-icon-loading" type="text"></el-button>
                        <span v-else>
                            <el-button @click="showNeedOutData(row)" type="text" style="padding: 0px" v-if="row.OrderWaitOutQuantity > 0">{{
                                row.OrderWaitOutQuantity
                            }}</el-button>
                            <span v-else>{{ row.OrderWaitOutQuantity }}</span></span
                        >
                    </template>
                </ux-table-column>
                <ux-table-column
                    v-if="columnShowSets.POrderWaitInQuantity.IsShow"
                    :width="columnShowSets.POrderWaitInQuantity.Width > 0 ? columnShowSets.POrderWaitInQuantity.Width + 'px' : '80px'"
                    :title="columnShowSets.POrderWaitInQuantity.ColumnName"
                    field="POrderWaitInQuantity"
                    key="POrderWaitInQuantity"
                    resizable
                    header-align
                >
                    <template v-slot="{ row }">
                        <el-button v-if="row.LoadSpaceInvent" icon="el-icon-loading" type="text"></el-button>
                        <span v-else>
                            <el-button @click="showNeedInData(row)" type="text" style="padding: 0px" v-if="row.POrderWaitInQuantity > 0">{{
                                row.POrderWaitInQuantity
                            }}</el-button>
                            <span v-else>{{ row.POrderWaitInQuantity }}</span></span
                        >
                    </template>
                </ux-table-column>
                <ux-table-column
                    v-if="columnShowSets.UpperLimit.IsShow"
                    :width="columnShowSets.UpperLimit.Width > 0 ? columnShowSets.UpperLimit.Width + 'px' : '80px'"
                    :title="columnShowSets.UpperLimit.ColumnName"
                    field="UpperLimit"
                    key="UpperLimit"
                    resizable
                    header-align
                ></ux-table-column>
                <ux-table-column
                    v-if="columnShowSets.LowerLimit.IsShow"
                    :width="columnShowSets.LowerLimit.Width > 0 ? columnShowSets.LowerLimit.Width + 'px' : '80px'"
                    :title="columnShowSets.LowerLimit.ColumnName"
                    field="LowerLimit"
                    key="LowerLimit"
                    resizable
                    header-align
                ></ux-table-column>
                <ux-table-column
                    field="PlanPurchase"
                    key="PlanPurchase"
                    v-if="columnShowSets.PlanPurchase.IsShow"
                    :width="columnShowSets.PlanPurchase.Width > 0 ? columnShowSets.PlanPurchase.Width + 'px' : '80px'"
                    :title="columnShowSets.PlanPurchase.ColumnName"
                    resizable
                    header-align
                >
                    <template v-slot="{ row }">
                        <el-button v-if="row.LoadSpaceInvent" icon="el-icon-loading" type="text"></el-button>
                        <span v-else>{{ row.PlanPurchase }}</span>
                    </template></ux-table-column
                >
                <ux-table-column
                    field="IntenCount"
                    key="IntenCount"
                    v-if="columnShowSets.IntenCount.IsShow"
                    :width="columnShowSets.IntenCount.Width > 0 ? columnShowSets.IntenCount.Width + 'px' : '80px'"
                    :title="columnShowSets.IntenCount.ColumnName"
                    resizable
                    header-align
                >
                    <template v-slot="{ row }">
                        <el-button v-if="row.LoadSpaceInvent" icon="el-icon-loading" type="text"></el-button>
                        <span v-else>
                            <el-button v-if="row.IntenCount > 0" @click="showIntentDatas(row.EntpTempGoodsId)" type="text" style="padding: 0px">{{
                                row.IntenCount
                            }}</el-button>
                            <span v-else>{{ row.IntenCount }}</span></span
                        >
                    </template></ux-table-column
                >
                <ux-table-column
                    field="Quality"
                    key="Quality"
                    sortable
                    remote-sort
                    v-if="columnShowSets.Quality.IsShow"
                    :width="columnShowSets.Quality.Width > 0 ? columnShowSets.Quality.Width + 'px' : '80px'"
                    :title="columnShowSets.Quality.ColumnName"
                    resizable
                    header-align
                ></ux-table-column>
                <ux-table-column
                    v-if="columnShowSets.Size2.IsShow"
                    :width="columnShowSets.Size2.Width > 0 ? columnShowSets.Size2.Width + 'px' : '140px'"
                    :title="columnShowSets.Size2.ColumnName"
                    field="Size2"
                    key="Size2"
                    resizable
                    header-align
                ></ux-table-column>
                <ux-table-column
                    v-if="columnShowSets.Cate.IsShow"
                    :width="columnShowSets.Cate.Width > 0 ? columnShowSets.Cate.Width + 'px' : '120px'"
                    :title="columnShowSets.Cate.ColumnName"
                    field="Cate"
                    key="Cate"
                    sortable
                    remote-sort
                    resizable
                    header-align
                >
                </ux-table-column>
                <ux-table-column
                    v-if="columnShowSets.Brand.IsShow"
                    :width="columnShowSets.Brand.Width > 0 ? columnShowSets.Brand.Width + 'px' : '120px'"
                    :title="columnShowSets.Brand.ColumnName"
                    field="Brand"
                    key="Brand"
                    sortable
                    remote-sort
                    resizable
                    header-align
                >
                </ux-table-column>
                <ux-table-column
                    field="Texture"
                    key="Texture"
                    v-if="columnShowSets.Texture.IsShow"
                    :width="columnShowSets.Texture.Width > 0 ? columnShowSets.Texture.Width + 'px' : '100px'"
                    :title="columnShowSets.Texture.ColumnName"
                    resizable
                    header-align
                ></ux-table-column>
                <ux-table-column
                    field="Color"
                    key="Color"
                    v-if="columnShowSets.Color.IsShow"
                    :width="columnShowSets.Color.Width > 0 ? columnShowSets.Color.Width + 'px' : '100px'"
                    :title="columnShowSets.Color.ColumnName"
                    resizable
                    header-align
                ></ux-table-column>
                <ux-table-column
                    field="GoodDesc"
                    key="GoodDesc"
                    v-if="columnShowSets.GoodDesc.IsShow"
                    :width="columnShowSets.GoodDesc.Width > 0 ? columnShowSets.GoodDesc.Width + 'px' : '200px'"
                    :title="columnShowSets.GoodDesc.ColumnName"
                    resizable
                    header-align
                ></ux-table-column>
                <ux-table-column
                    field="CreateTime"
                    key="CreateTime"
                    sortable
                    remote-sort
                    v-if="columnShowSets.CreateTime.IsShow"
                    :width="columnShowSets.CreateTime.Width > 0 ? columnShowSets.CreateTime.Width + 'px' : '160px'"
                    :title="columnShowSets.CreateTime.ColumnName"
                    resizable
                    header-align
                ></ux-table-column>
            </ux-grid>

            <div class="invens-summary" v-if="isShowSummary">
                <span class="title">各仓库库存数据：</span>
                <div v-for="item in summaryList" :key="item.Name" class="summary-item">
                    <span class="sname">【 {{ item.Name }} 】</span>
                    <span class="sname">库存数：</span>
                    <span class="scount"> {{ item.Count }} </span>
                </div>
            </div>
        </div>
        <div class="section-title" @click="hideMsg()">
            <div>订单商品明细</div>
        </div>
        <!-- table body -->
        <div id="infinite-list" @click="hideMsg()" class="sales-order-edit">
            <ux-grid
                ref="infiniteTable"
                :data="dataList"
                keep-source
                height="314px"
                :highlight-current-row="false"
                :edit-config="{ trigger: 'click', mode: 'row' }"
                :row-style="setRowStyle"
                row-id="rowkey"
                empty-text="暂无报价商品明细"
            >
                <ux-table-column class-name="table-sort" type="index" title="序号" width="65" resizable></ux-table-column>
                <ux-table-column field="APCode" title="汽配编码" edit-render show-overflow-tooltip resizable>
                    <template v-slot:header="{ column }">
                        <div class="head-view">
                            <span class="color-red">*</span>
                            {{ column.title }}
                            <span class="sort-view">
                                <i
                                    :class="['el-icon-caret-top', { active: sortActive === 'top' }]"
                                    title="升序,从小到大排序"
                                    @click="changeTableSort('top', 'APCode')"
                                ></i>
                                <i
                                    :class="['el-icon-caret-bottom', { active: sortActive === 'bottom' }]"
                                    title="降序,从大到小排序"
                                    @click="changeTableSort('bottom', 'APCode')"
                                ></i>
                            </span>
                        </div>
                    </template>
                    <template v-slot="{ row, rowIndex }">
                        <div :class="['sales-apcode div-padding-12', { 'special-border': !row.APCode }]" @click="focusHandle('sapcode')">
                            <span class="sp-i" v-show="row.APCode">
                                <i title="配件信息" class="el-icon-info" @click.stop="showAPMsgDialog(row.EntpTempGoodsId)"></i>
                            </span>
                            <span>{{ row.APCode ? row.APCode : '请点击选中汽配编码' }}</span>
                            <el-tag v-if="row.State == 1" class="tag" type="warning">已删除</el-tag>
                        </div>
                    </template>
                    <template v-slot:edit="scope">
                        <el-select
                            style="width: 100%"
                            ref="sapcode"
                            :disabled="dataReadonly || scope.row.hasLock"
                            default-first-option
                            size="small"
                            v-model="scope.row.APCode"
                            value-key="APCode"
                            filterable
                            remote
                            reserve-keyword
                            placeholder="汽配编码"
                            @change="codeChange($event, scope.rowIndex)"
                            @visible-change="apCodeVisibleChange($event)"
                            :remote-method="
                                query => {
                                    searchCode(query, scope.row, scope.rowIndex);
                                }
                            "
                            v-select-scroll-more="searchCodeLoad"
                            popper-class="el-select-style-gray"
                            @keyup.right.native="keyEvent($event, 'APCode')"
                        >
                            <el-option
                                v-for="optionItem in codeList"
                                :key="optionItem.EntpTempGoodsId"
                                :data-msg="optionItem"
                                :label="optionItem.APCode"
                                :value="optionItem.EntpTempGoodsId"
                            >
                                <div class="option-content">
                                    <div class="project-Name">{{ optionItem.APCode }}</div>
                                    <div class="project-Name">{{ optionItem.GoodName }}</div>
                                    <div class="project-Name">{{ optionItem.AutoSerise }}</div>
                                    <div class="project-Name" v-if="changeCodeConfig">
                                        {{ optionItem.GoodCode }}
                                    </div>
                                </div>
                            </el-option>
                            <el-option v-if="loading" disabled value="" style="text-align: center">
                                加载中
                                <i class="el-icon-loading"></i>
                            </el-option>
                        </el-select>
                    </template>
                </ux-table-column>
                <ux-table-column field="GoodNameItem" title="配件名称" edit-render show-overflow-tooltip resizable>
                    <template v-slot:header="{ column }">
                        <span class="color-red">*</span>
                        {{ column.title }}
                    </template>
                    <template v-slot="{ row, rowIndex }">
                        <div :class="['div-padding-12', { 'special-border': !row.GoodName }]" @click="focusHandle('partsNameSelect')">
                            {{ row.GoodName }}
                        </div>
                    </template>
                    <template v-slot:edit="scope">
                        <el-input
                            size="small"
                            placeholder="配件名称"
                            ref="partsNameSelect"
                            v-model="scope.row.GoodName"
                            :disabled="scope.row.hasLock"
                            @keyup.right.native="keyEvent($event, 'GoodName')"
                            @keyup.left.native="keyEvent($event, 'GoodName')"
                            @focus="selectAutoHandle('partsNameSelect')"
                        ></el-input>
                    </template>
                </ux-table-column>
                <ux-table-column field="AutoSeriseItem" title="车型" edit-render show-overflow-tooltip resizable>
                    <template v-slot:header="{ column }">
                        <span class="color-red">*</span>
                        {{ column.title }}
                    </template>
                    <template v-slot="{ row, rowIndex }">
                        <el-tooltip effect="dark" :content="row.AutoSerise ? row.AutoSerise.toString() : ''" :disabled="!row.AutoSerise" placement="top">
                            <div :class="['div-padding-12', { 'special-border': !row.AutoSerise }]" @click="focusHandle('autoSeriseSelect')">
                                {{ row.AutoSerise }}
                            </div>
                        </el-tooltip>
                    </template>
                    <template v-slot:edit="scope">
                        <el-input
                            size="small"
                            v-model="scope.row.AutoSerise"
                            placeholder="车系"
                            :disabled="scope.row.hasLock"
                            @keyup.right.native="keyEvent($event, 'AutoSerise')"
                            @keyup.left.native="keyEvent($event, 'AutoSerise')"
                            @focus="selectAutoHandle('autoSeriseSelect')"
                            ref="autoSeriseSelect"
                        ></el-input>
                    </template>
                </ux-table-column>
                <ux-table-column field="Brand" title="品牌" v-if="isShowBrand" width="90" resizable key="Brand">
                    <template v-slot="{ row }">
                        <div class="div-padding-12">{{ row.Brand }}</div>
                    </template>
                </ux-table-column>
                <ux-table-column field="Origin" title="产地" v-if="isOriginShow" width="160" :edit-render="{ autofocus: '.el-input__inner' }" resizable key="origin">
                    <template v-slot="{ row }">
                        <div class="div-padding-12" @click="focusHandle('originRef')">{{ row.Origin }}</div>
                    </template>
                    <template v-slot:edit="scope">
                        <el-input
                            ref="originRef"
                            size="small"
                            v-model="scope.row.Origin"
                            @keyup.right.native="keyEvent($event, 'Origin')"
                            @keyup.left.native="keyEvent($event, 'Origin')"
                            @focus="selectAutoHandle('originRef')"
                            :disabled="dataReadonly"
                        ></el-input>
                    </template>
                </ux-table-column>
                <ux-table-column field="Size" title="规格" v-if="isSizeShow" width="160" resizable key="Size">
                    <template v-slot="{ row }">
                        <div class="div-padding-12">{{ row.Size }}</div>
                    </template>
                </ux-table-column>
                <!--autofocus，如果是自定义渲染可以指定聚焦的选择器，他的作用很明显就是你点击一下就帮你去获取焦点。
                你无需点击第二次再去获取焦点。autofocus的值就是你编辑型输入框（edit）组件的类名-->
                <ux-table-column field="Count" title="数量" width="100" :edit-render="{ autofocus: '.el-input__inner' }" resizable>
                    <template v-slot="{ row }">
                        <div class="div-padding-12" @click="focusHandle('sapcode')">{{ row.Count }}</div>
                    </template>
                    <template v-slot:edit="scope">
                        <div class="salecounts-input-cell">
                            <el-input-number
                                type="number"
                                ref="countRef"
                                :min="1"
                                :precision="0"
                                controls-position="right"
                                size="small"
                                v-model="scope.row.Count"
                                @change="priceChange"
                                @keyup.right.native="keyEvent($event, 'Count')"
                                @keyup.left.native="keyEvent($event, 'Count')"
                                @focus="selectAutoHandle('countRef')"
                                :disabled="dataReadonly"
                            ></el-input-number>
                        </div>
                    </template>
                </ux-table-column>
                <ux-table-column field="Unit" title="单位" width="100" edit-render resizable>
                    <template v-slot:header="{ column }">
                        <span class="color-red">*</span>
                        {{ column.title }}
                    </template>
                    <template v-slot="{ row, rowIndex }">
                        <div :class="['div-padding-12', { 'special-border': !row.Unit }]" @click="focusHandle('unitSelect')">
                            {{ row.Unit }}
                        </div>
                    </template>
                    <template v-slot:edit="scope">
                        <el-select
                            ref="unitSelect"
                            :disabled="dataReadonly"
                            default-first-option
                            size="small"
                            v-model="scope.row.Unit"
                            filterable
                            clearable
                            remote
                            reserve-keyword
                            placeholder="单位"
                            @visible-change="unitVisibleChange($event)"
                            @keyup.right.native="keyEvent($event, 'Unit')"
                            @keyup.left.native="keyEvent($event, 'Unit')"
                            popper-class="el-select-style-gray"
                        >
                            <el-option v-for="optionItem in unitList" :key="optionItem.Value" :label="optionItem.Value" :value="optionItem.Value"></el-option>
                        </el-select>
                    </template>
                </ux-table-column>
                <ux-table-column field="MarketPrice" title="销售价" width="120" :edit-render="{ autofocus: '.el-input__inner' }" resizable>
                    <template v-slot:header="{ column }">
                        <el-tooltip effect="dark" placement="bottom" :tabindex="-1">
                            <div slot="content">
                                当配件商品有过销售历史且该客户有购买历史时，显示该客户购买配件商品的最新销售价格；
                                <br />若配件商品从未销售过，则不显示数值
                            </div>
                            <span>
                                <i class="el-icon-warning-outline" style="color: orange; margin-right: 5px"></i>
                                <span class="color-red">*</span>
                            </span>
                        </el-tooltip>
                        {{ column.title }}
                    </template>
                    <template v-slot="{ row }">
                        <el-tooltip effect="dark" placement="right">
                            <div slot="content">
                                利润率：{{ row.MarketPrice != 0 && row.CostPrice != 0 ? (((row.MarketPrice - row.CostPrice) / row.CostPrice) * 100).toFixed(2) : 0 }}%
                            </div>
                            <div
                                :class="[
                                    'div-padding-12',
                                    {
                                        'special-border': CheckLoseMoney(row.CostPrice, row.MarketPrice) || !row.MarketPrice
                                    }
                                ]"
                            >
                                <span
                                    :class="{
                                        'color-red': row.MarketPrice === 0 || row.MarketPrice < row.CostPrice
                                    }"
                                    >{{ row.MarketPrice }}</span
                                >
                            </div>
                        </el-tooltip>
                    </template>
                    <template v-slot:edit="scope">
                        <div
                            class="sales-input-cell"
                            v-if="(LoseMoneyValue && !dataReadonly) || priceCanBeEdit"
                            :class="{
                                loseMoneyWarning: CheckLoseMoney(scope.row.CostPrice, scope.row.MarketPrice)
                            }"
                        >
                            <el-tooltip :disabled="!CheckLoseMoney(scope.row.CostPrice, scope.row.MarketPrice)" effect="light" placement="right">
                                <div slot="content">销售价低于成本价{{ LoseMoneyValue }}%</div>
                                <el-input-number
                                    ref="marketPirceRef"
                                    size="small"
                                    :precision="2"
                                    :step="0.1"
                                    controls-position="right"
                                    v-model="scope.row.MarketPrice"
                                    placeholder="销售价"
                                    @input="priceChange"
                                    @keyup.left.native="keyEvent($event, 'MarketPrice')"
                                    @keyup.right.native="keyEvent($event, 'MarketPrice')"
                                    @focus="selectAutoHandle('marketPirceRef')"
                                    :disabled="dataReadonly"
                                >
                                </el-input-number>
                            </el-tooltip>
                        </div>
                        <div class="sales-input-cell" v-else>
                            <el-input-number
                                size="small"
                                :disabled="dataReadonly || !priceCanBeEdit"
                                :min="0"
                                :precision="2"
                                :step="0.01"
                                controls-position="right"
                                v-model="scope.row.MarketPrice"
                                placeholder="销售价"
                                @input="priceChange"
                                @keyup.left.native="keyEvent($event, 'MarketPrice')"
                                @keyup.right.native="keyEvent($event, 'MarketPrice')"
                            ></el-input-number>
                        </div>
                    </template>
                </ux-table-column>
                <ux-table-column
                    field="BillingPrice"
                    title="开单价"
                    width="120"
                    v-if="isBPriceShow"
                    :edit-render="{ autofocus: '.el-input__inner' }"
                    resizable
                    key="BillingPrice"
                >
                    <template v-slot="{ row }">
                        <div class="div-padding-12">{{ row.BillingPrice }}</div>
                    </template>
                    <template v-slot:edit="scope">
                        <div class="sales-input-cell">
                            <el-input-number
                                ref="billingPriceRef"
                                size="small"
                                :precision="2"
                                :step="0.1"
                                controls-position="right"
                                v-model="scope.row.BillingPrice"
                                placeholder="开单价"
                                @keyup.left.native="keyEvent($event, 'BillingPrice')"
                                @focus="selectAutoHandle('billingPriceRef')"
                                :disabled="dataReadonly"
                            >
                            </el-input-number>
                        </div>
                    </template>
                </ux-table-column>
                <ux-table-column field="xszj" title="销售总价" width="120" resizable>
                    <template v-slot="{ row }">
                        <div class="div-padding-12">
                            {{ ((row.MarketPrice ? row.MarketPrice : 0) * (row.Count ? row.Count : 0)).toFixed(2) }}
                        </div>
                    </template>
                </ux-table-column>
                <ux-table-column title="操作" width="120" v-if="type !== 0" resizable>
                    <template v-slot="{ row, rowIndex }">
                        <div class="operate">
                            <el-button
                                size="small"
                                @click="delItem(rowIndex, row)"
                                icon="el-icon-delete"
                                :tabindex="-1"
                                v-if="dataList.length !== 1 && !dataReadonly"
                            ></el-button>
                            <el-button
                                size="small"
                                type="primary"
                                @click="addItem(true)"
                                icon="el-icon-plus"
                                v-if="rowIndex + 1 === dataList.length && !dataReadonly"
                            ></el-button>
                            <el-button
                                size="small"
                                @click="upLock(rowIndex)"
                                :icon="row.hasLock ? 'el-icon-lock' : 'el-icon-unlock'"
                                v-if="isLock && lastRowIndex !== rowIndex"
                            ></el-button>
                        </div>
                    </template>
                </ux-table-column>
            </ux-grid>
        </div>
        <el-dialog :close-on-click-modal="false" :title="customerEditType == 2 ? '编辑客户' : '新增客户'" :visible.sync="dialogVisible" width="1000px">
            <div class="dialog-content" v-if="dialogVisible">
                <customerEdit ref="customerEdit" :cusId="submitData.EntpCusId" :type="customerEditType" source="1" @closeDialog="closeDialog"></customerEdit>
            </div>
        </el-dialog>
        <!--   配件信息     -->
        <el-dialog :close-on-click-modal="false" title="配件信息" :visible.sync="APMsgVisible" width="1000px">
            <div v-if="APMsgVisible">
                <APMsg :dialogFormVisible="APMsgVisible" :EntpTempGoodsId="EntpTempGoodsIdEdit" @closeDialog="closeAPMsgDialog"></APMsg>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" title="自定义列展示设置" @close="closeDialog" :visible.sync="tableSetsVisible" append-to-body width="600px">
            <div class="dialog-content" v-if="tableSetsVisible">
                <tableSets :tableCode="tableCode" @closeDialog="closeDialog"></tableSets>
            </div>
        </el-dialog>
        <el-dialog
            :close-on-click-modal="false"
            title="配件搜索"
            :visible.sync="searchVisible"
            width="400px"
            append-to-body
            v-dialog-drag
            lock-scroll
            :modal="false"
            id="search-dc-dialog"
            custom-class="search-item-dialog"
            style="margin-left: -170px"
            @close="closeSearchDialog"
        >
            <div class="dialog-content" v-if="searchVisible">
                <el-form ref="form" label-position="left" label-width="82px">
                    <el-form-item label="联合搜索">
                        <el-input
                            ref="search_0"
                            class="search-item"
                            style="width: 100%"
                            size="small"
                            clearable
                            v-model="searchData.JointSearch"
                            :placeholder="'用分隔符“' + (separator == ' ' ? '空格' : separator) + '”隔开'"
                            @focus="selectAutoHandle('search_0')"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="配件编码">
                        <el-input
                            ref="search_1"
                            class="search-item"
                            style="width: 100%"
                            size="small"
                            v-model="searchData.APCode"
                            placeholder="请输入配件编码"
                            @focus="selectAutoHandle('search_1')"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="配件名称">
                        <el-autocomplete
                            ref="search_2"
                            size="small"
                            style="width: 100%"
                            v-model="searchData.GoodName"
                            :fetch-suggestions="searchGoodName"
                            :debounce="500"
                            placeholder="请输入配件名称"
                            :trigger-on-focus="false"
                            @select="stopSearch"
                            v-scrollLoad="searchGoodNameLoad"
                        ></el-autocomplete>
                    </el-form-item>
                    <el-form-item label="适用车型">
                        <el-autocomplete
                            ref="search_3"
                            size="small"
                            style="width: 100%"
                            :debounce="500"
                            v-model="searchData.AutoSerise"
                            :fetch-suggestions="searchAutoSerise"
                            placeholder="请输入车型"
                            :trigger-on-focus="false"
                            @select="stopSearch"
                            v-scrollLoad="searchAutoSeriseLoad"
                        ></el-autocomplete>
                    </el-form-item>
                    <el-form-item label="互换码">
                        <el-input
                            ref="search_4"
                            style="width: 100%"
                            size="small"
                            v-model="searchData.GoodCode"
                            placeholder="请输入互换码"
                            @focus="selectAutoHandle('search_4')"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="汽配分类">
                        <el-select
                            ref="search_5"
                            size="small"
                            style="width: 100%"
                            v-model="searchData.Cate"
                            multiple
                            collapse-tags
                            filterable
                            clearable
                            @visible-change="getGoodsType($event)"
                        >
                            <el-option v-for="optionItem in typeList" :key="optionItem.Value" :label="optionItem.Text" :value="optionItem.Value">
                                <div class="option-content">
                                    <div>{{ optionItem.Text }}</div>
                                </div>
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="汽配品牌">
                        <el-select
                            ref="search_6"
                            v-model="searchData.BrandName"
                            multiple
                            collapse-tags
                            filterable
                            clearable
                            size="small"
                            style="width: 100%"
                            @visible-change="getGoodsBrand($event)"
                        >
                            <el-option :key="item.Text" v-for="item in brandList" :label="item.Text" :value="item.Text"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="库存数">
                        <div class="flex">
                            <el-select size="small" class="search-item" style="width: 90px" v-model="searchData.Symbol" clearable placeholder="符号">
                                <el-option key=">=" label=">=" value=">="></el-option>
                                <el-option key=">" label=">" value=">"></el-option>
                                <el-option key="<=" label="<=" value="<="></el-option>
                                <el-option key="<" label="<" value="<"></el-option>
                                <el-option key="=" label="=" value="="></el-option>
                                <el-option key="!=" label="!=" value="!="></el-option>
                                <el-option key="between" label="区间" value="between"></el-option>
                            </el-select>
                            <el-input
                                ref="search_7"
                                class="search-item"
                                size="small"
                                style="width: 90px"
                                v-model.trim="searchData.Invent1"
                                @focus="selectAutoHandle('search_7')"
                            ></el-input>
                            <el-input
                                class="search-item"
                                size="small"
                                style="width: 90px"
                                v-model.trim="searchData.Invent2"
                                v-if="searchData.Symbol == 'between'"
                            ></el-input>
                        </div>
                    </el-form-item>
                    <el-form-item label="尺寸">
                        <el-input
                            ref="search_8"
                            class="search-item"
                            style="width: 100%"
                            size="small"
                            v-model="searchData.Size"
                            placeholder="请输入尺寸"
                            @focus="selectAutoHandle('search_8')"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="产地">
                        <el-input
                            ref="search_9"
                            class="search-item"
                            style="width: 100%"
                            size="small"
                            v-model="searchData.Origin"
                            placeholder="请输入产地信息"
                            @focus="selectAutoHandle('search_9')"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="自定义属性">
                        <el-input
                            ref="search_10"
                            class="search-item"
                            style="width: 100%"
                            size="small"
                            v-model="searchData.GoodDesc"
                            placeholder="请输入属性值"
                            @focus="selectAutoHandle('search_10')"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="查询公式">
                        <el-radio-group v-model="searchData.SearchType">
                            <el-radio :label="0">左等</el-radio>
                            <el-radio :label="1">全等</el-radio>
                            <el-radio :label="2">包含</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-form>
                <div class="dialog-footer">
                    <el-button size="small" type="primary" @click="jointSets">设置查询条件</el-button>
                    <el-button size="small" @click="resetSearch">重置</el-button>
                    <el-button class="btn-primary" size="small" @click="handleSearch">查询（Enter）</el-button>
                </div>
            </div>
        </el-dialog>
        <!--    销售历史    -->
        <el-dialog :close-on-click-modal="false" title="销售历史" :visible.sync="historyVisible" width="1200px">
            <div v-if="historyVisible">
                <APHistory
                    :EntpCusId="submitData.EntpCusId"
                    :EntpTempGoodsId="EntpTempGoodsIdEdit"
                    :EntpCusName="submitData.EntpCusName"
                    @closeDialog="closeHistoryDialog"
                ></APHistory>
            </div>
        </el-dialog>
        <!--    采购历史    -->
        <el-dialog :close-on-click-modal="false" title="采购历史" :visible.sync="historyPurVisible" width="1200px">
            <div v-if="historyPurVisible">
                <APPurchaseHistory :EntpTempGoodsId="EntpTempGoodsIdEdit" :Source="1" @closeDialog="closeHistoryDialog"></APPurchaseHistory>
            </div>
        </el-dialog>
        <!--    报价历史    -->
        <el-dialog :close-on-click-modal="false" title="报价历史" :visible.sync="historyQuoteVisible" width="1200px">
            <div v-if="historyQuoteVisible">
                <APQuoteHistory
                    :EntpCusId="submitData.EntpCusId"
                    :EntpTempGoodsId="EntpTempGoodsIdEdit"
                    :EntpCusName="submitData.EntpCusName"
                    @closeDialog="closeQuoteHistoryDialog"
                ></APQuoteHistory>
            </div>
        </el-dialog>
        <el-dialog
            :close-on-click-modal="false"
            title="配件在订数据"
            :visible.sync="inqHistoryVisible"
            append-to-body
            v-dialog-drag
            lock-scroll
            :modal="false"
            id="change-dialog"
            style="margin-left: -500px"
            width="900px"
        >
            <div v-if="inqHistoryVisible">
                <APInquiryHistory
                    ref="APInquiryHistory"
                    :EntpTempGoodsId="hisGoodsId"
                    :Source="1"
                    @closeDialog="
                        () => {
                            inqHistoryVisible = false;
                        }
                    "
                ></APInquiryHistory>
            </div>
        </el-dialog>
        <el-dialog
            :title="NeedITitle"
            :close-on-click-modal="false"
            :visible.sync="needInDataVisible"
            append-to-body
            v-dialog-drag
            lock-scroll
            :modal="false"
            id="change-dialog"
            style="margin-left: -500px"
            width="900px"
        >
            <div v-if="needInDataVisible">
                <APNeedInDatas ref="APNeedInDatas" :EntpTempGoodsId="EntpTempGoodsId" @closeDialog="needInDataVisible = false"></APNeedInDatas>
            </div>
        </el-dialog>
        <el-dialog
            :title="NeedOTitle"
            :close-on-click-modal="false"
            :visible.sync="needOutDataVisible"
            append-to-body
            v-dialog-drag
            lock-scroll
            :modal="false"
            id="change-dialog"
            style="margin-left: -500px"
            width="900px"
        >
            <div v-if="needOutDataVisible">
                <APNeedOutDatas ref="APNeedOutDatas" :EntpTempGoodsId="EntpTempGoodsId" @closeDialog="needOutDataVisible = false"></APNeedOutDatas>
            </div>
        </el-dialog>
        <el-dialog
            :close-on-click-modal="false"
            title="加入清单"
            width="400px"
            :visible.sync="rowVisible"
            append-to-body
            v-dialog-drag
            lock-scroll
            :modal="false"
            id="comfirm-ap-dialog"
            custom-class="search-item-dialog"
            style="margin-left: -170px"
        >
            <div class="dialog-content" v-if="rowVisible" v-loading="rowFormLoading">
                <el-form label-position="left" label-width="70px" :model="rowForm">
                    <el-form-item label="汽配编码">
                        <el-input v-model="rowForm.APCode" disabled size="small" />
                    </el-form-item>
                    <el-form-item label="配件名称">
                        <el-input v-model="rowForm.GoodName" disabled size="small" />
                    </el-form-item>
                    <el-form-item label="车型">
                        <el-input v-model="rowForm.AutoSerise" disabled size="small" />
                    </el-form-item>
                    <el-form-item label="参考价格">
                        <el-input v-model="rowForm._referencePrice" disabled size="small" />
                    </el-form-item>
                    <el-form-item label="数量">
                        <el-input
                            :min="1"
                            @input="change($event)"
                            ref="confirm_0"
                            key="confirm_0"
                            v-model="rowForm._count"
                            size="small"
                            style="width: 100%"
                            @focus="selectAutoHandle('confirm_0')"
                            type="number"
                        />
                    </el-form-item>
                    <el-form-item label="价格">
                        <el-input
                            :min="0"
                            @input="change($event, 1)"
                            ref="confirm_1"
                            v-model="rowForm._price"
                            size="small"
                            style="width: 100%"
                            @focus="selectAutoHandle('confirm_1')"
                            type="number"
                        />
                    </el-form-item>
                    <el-form-item label="开单价" v-if="isBPriceShow">
                        <el-input
                            :min="0"
                            @input="change($event, 2)"
                            ref="confirm_2"
                            v-model="rowForm._biilPrice"
                            size="small"
                            @focus="selectAutoHandle('confirm_2')"
                            style="width: 100%"
                            type="number"
                        />
                    </el-form-item>
                </el-form>
            </div>
            <div class="dialog-footer">
                <el-button class="btn-primary" size="small" @click="rowConfirm" :disabled="rowFormLoading">加入清单(Enter)</el-button>
                <el-button size="small" @click="rowClose" :disabled="rowFormLoading">取消(ESC)</el-button>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" title="自定义搜索条件展示设置" @close="closeJointDialog" :visible.sync="jointSetVisible" append-to-body width="400px">
            <div class="dialog-content" v-if="jointSetVisible">
                <jointSets @closeDialog="closeJointDialog"></jointSets>
            </div>
        </el-dialog>
        <el-dialog
            :close-on-click-modal="false"
            title="主图"
            width="150px"
            :visible.sync="imageVisible && currentRow.MainImage !== ''"
            v-dialog-drag
            append-to-body
            lock-scroll
            :modal="false"
            id="ap-image-dialog"
            custom-class="image-item-dialog"
        >
            <div style="padding-top: 5px" v-if="imageVisible && currentRow.MainImage">
                <el-image
                    style="width: 100px; height: 100px"
                    :src="downloadUrl + currentRow.MainImage + '?imageView2/2/w/100'"
                    @click="getGoodsImages()"
                    fit="contain"
                    lazy
                ></el-image>
            </div>
        </el-dialog>
        <!-- 进度条 -->
        <el-progress v-if="searchApParams._visible" class="saveProgress" type="circle" :percentage="searchApParams._percentage" />
        <!-- 新增库存 -->
        <transInventory v-if="addAPVisible" :dialogFormVisible="addAPVisible" :apParams="addAPParams" @closeDialog="closeAddAPDialog"></transInventory>
        <el-image-viewer v-if="showViewer" :on-close="closeViewer" :url-list="srcList" :z-index="99999" />
    </div>
</template>
<script>
import customerEdit from '@/components/business/customerManage/customerEdit';
import APMsg from '@/components/common/APMsg';
import APHistory from '@/components/common/APHistory';
import APQuoteHistory from '@/components/common/APQuoteHistory';
import APPurchaseHistory from '@/components/common/APPurchaseHistory';
import APInquiryHistory from '@/components/common/APInquiryHistory';
import APNeedInDatas from '@/components/common/APNeedInDatas';
import APNeedOutDatas from '@/components/common/APNeedOutDatas';
import mixin from '@/mixins/mixin';
import transInventory from '@/components/business/search/transInventory';
import jointSets from '@/components/common/jointSets.vue';
import tableSets from '@/components/common/tableSets.vue';
import ElImageViewer from 'element-ui/packages/image/src/image-viewer';
export default {
    mixins: [mixin],
    name: '',
    components: {
        customerEdit,
        APMsg,
        APHistory,
        APQuoteHistory,
        APPurchaseHistory,
        APInquiryHistory,
        APNeedInDatas,
        APNeedOutDatas,
        transInventory,
        jointSets,
        tableSets,
        ElImageViewer
    },
    data() {
        let checkPositive = this.$util.checkPositive;
        let userMsg = this.$util.getLocalStorage('userMsg');
        return {
            downloadUrl: this.$util.QN_URL_BASE,
            isCheckCode: true,
            isCanTBSet: false,
            confirmIndex: 0,
            searchIndex: 0,
            currentRow: {},
            dataindex: 0,
            datetime: '',
            permission: [],
            tableCode: 'SearchAP',
            isUseSE: false,
            isStartSearch: false,
            isStartConfirm: false,
            userMsg: userMsg,
            searchLoading: false,
            saving: false,
            needConfirm: true,
            dialogVisible: false,
            searchVisible: false,
            historyVisible: false,
            historyQuoteVisible: false,
            APMsgVisible: false,
            // 新增库存
            addAPVisible: false,
            tableSetsVisible: false,
            jointSetVisible: false,
            dialogCusVisible: false,
            inqHistoryVisible: false,
            historyPurVisible: false,
            needInDataVisible: false,
            needOutDataVisible: false,
            EntpTempGoodsIdEdit: '',
            showHistory: false,
            historyNoData: true,
            loading: false,
            showOrderMsg: true,
            canRequest: true,
            customerEditType: 1,
            dataReadonly: false,
            showResultMsg: false,
            submitData: {
                QuoteId: '',
                UserId: userMsg.EmployeeId,
                EntpCusId: '',
                NeedTime: '',
                Remark: '',
                PriceSumShip: '',
                ITime: '',
                QTime: '',
                IsSubmitReview: false,
                CreatorType: 0,
                WarehouseId: '',
                OId: '', // 销售退货单id/销售单id，转报价使用
                DetailList: []
            },
            Limit: 10,
            customerList: [],
            codeList: [],
            dataList: [],
            unitList: [],
            typeList: [],
            brandList: [],
            type: 1, //  1 查看 2 编辑 3 新增 4 销售转报价（目前没有用到） 5复制报价单 6销售退货转报价
            id: '',
            pageTitle: '',
            rules: {
                EntpCusId: [{ required: true, message: '请选择客户', trigger: 'blur' }],
                PriceSumShip: [{ required: false, validator: checkPositive, trigger: 'blur' }]
            },

            infiniteListHeight: 0, // 列表高度，在收起信息栏时进行实时计算
            selectedData: [],
            apcodeSource: null,
            // 是否预先加载汽配编码列表数据
            isPreloadApCodeList: false,
            // 用于客户名称列表，分页搜索
            cusForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            // 用于汽配编码列表，分页搜索功能
            codeForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            // 加锁：选择商品完成回车或点加号后触发锁定不可修改
            hasLock: false,
            // 汽配编码排序标识
            sortActive: '',
            // 搜索配件弹框返回参数
            searchApParams: {
                _visible: false,
                _percentage: 0,
                _limit: 500,
                // 总数量
                _totalCount: 0
            },
            // 功能配置项：初始数量值
            initNumber: 1,
            isAddWaitIn: true,
            addAPParams: {},
            changeCodeConfig: true,
            warehouseList: [], //仓库地址
            warehouseType: '',
            isInvenShow: false,
            isBPriceShow: false, //开单价
            isOriginShow: false, //产地
            isSizeShow: false, //规格
            tableData: [],
            tableDataLength: 0,
            searchData: {
                APCode: '',
                GoodCode: '',
                GoodName: '',
                GoodDesc: '',
                AutoSerise: '',
                Brand: '',
                BrandName: [],
                Size: '',
                Cate: [],
                page: 1,
                limit: 15,
                CId: '',
                SId: '',
                SortProp: '',
                SortType: '',
                Source: '0',
                JointSearch: '',
                Symbol: '',
                Invent1: 0,
                Invent2: 0,
                Origin: '',
                SearchType: 2
            },
            columnShowSets: {
                APCode: {
                    ColumnName: '',
                    IsShow: false,
                    Width: 0
                },
                GoodCode: {
                    ColumnName: '',
                    IsShow: false,
                    Width: 0
                },
                GoodName: {
                    ColumnName: '',
                    IsShow: false,
                    Width: 0
                },
                AutoSerise: {
                    ColumnName: '',
                    IsShow: false,
                    Width: 0
                },
                GeneralModels: {
                    ColumnName: '',
                    IsShow: false,
                    Width: 0
                },
                CostPrice: {
                    ColumnName: '',
                    IsShow: false,
                    Width: 0
                },
                Price: {
                    ColumnName: '',
                    IsShow: false,
                    Width: 0
                },
                MarketPrice: {
                    ColumnName: '',
                    IsShow: false,
                    Width: 0
                },
                Inventory: {
                    ColumnName: '',
                    IsShow: false,
                    Width: 0
                },
                Remaining: {
                    Remaining: '',
                    IsShow: false,
                    Width: 0
                },
                OrderWaitOutQuantity: {
                    ColumnName: '',
                    IsShow: false,
                    Width: 0
                },
                POrderWaitInQuantity: {
                    ColumnName: '',
                    IsShow: false,
                    Width: 0
                },
                UpperLimit: {
                    ColumnName: '',
                    IsShow: false,
                    Width: 0
                },
                LowerLimit: {
                    ColumnName: '',
                    IsShow: false,
                    Width: 0
                },
                Unit: {
                    ColumnName: '',
                    IsShow: false,
                    Width: 0
                },
                Cate: {
                    ColumnName: '',
                    IsShow: false,
                    Width: 0
                },
                Brand: {
                    ColumnName: '',
                    IsShow: false,
                    Width: 0
                },
                Origin: {
                    ColumnName: '',
                    IsShow: false,
                    Width: 0
                },
                Quality: {
                    ColumnName: '',
                    IsShow: false,
                    Width: 0
                },
                Size: {
                    ColumnName: '',
                    IsShow: false,
                    Width: 0
                },
                Size2: {
                    ColumnName: '',
                    IsShow: false,
                    Width: 0
                },
                Texture: {
                    ColumnName: '',
                    IsShow: false,
                    Width: 0
                },
                Color: {
                    ColumnName: '',
                    IsShow: false,
                    Width: 0
                },
                GoodDesc: {
                    ColumnName: '',
                    IsShow: false,
                    Width: 0
                },
                UpdateTime: {
                    ColumnName: '',
                    IsShow: false,
                    Width: 0
                },
                CreateTime: {
                    ColumnName: '',
                    IsShow: false,
                    Width: 0
                },
                PlanPurchase: {
                    ColumnName: '',
                    IsShow: false,
                    Width: 0
                },
                IntenCount: {
                    ColumnName: '',
                    IsShow: false,
                    Width: 0
                }
            },
            separator: '',
            pickerOptions: {
                shortcuts: [
                    {
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近半年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
                            picker.$emit('pick', [start, end]);
                        }
                    }
                ]
            },
            scrollTop: 0,
            scrollLeft: 0,
            NeedITitle: '',
            NeedOTitle: '',
            rowVisible: false,
            rowForm: {},
            allNum: 0,
            allMoney: 0,
            timer: null, //保存setTimeout定时器对象
            imageVisible: false,
            srcList: [],
            showViewer: false,
            LoseMoneyValue: false,
            priceCanBeZero: false,
            canSearch: true,
            rowFormLoading: false,
            isShowSummary: false,
            summaryList: [],
            isOriginSort: false,
            nameCallBack: '',
            autoCallBack: '',
            goodNameOptions: [],
            goodNameForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            autoSeriseOptions: [],
            autoSeriseForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            isShowBrand: false //是否显示品牌
        };
    },
    beforeRouteLeave(to, from, next) {
        this.$util.confirmBeforeLeave(to, from, next, this);
    },
    created() {
        document.addEventListener('keydown', this.handleKeyEvent);
        if (this.tableCode) {
            this.getSetsData();
            this.getJointSearchSets();
        }
    },
    watch: {
        $route(to, from) {
            if (to === this.$route) {
                this.init();
                this.submitData = {};
                this.allMoney = 0;
                this.allNum = 0;
                this.dataList = [];
            }
        },
        isStartSearch(newVal, oldVal) {
            if (newVal === true) {
                this.$nextTick(() => {
                    this.$refs.search_0.focus();
                    this.searchIndex = 0;
                });
            }
        },
        currentRow(newVal, oldVal) {
            this.srcList = [];
            if (newVal && newVal.MainImage && newVal.MainImage != oldVal.MainImage) {
                this.$nextTick(() => {
                    this.imageVisible = true;
                });
            } else {
                this.imageVisible = false;
            }
        },
        isStartConfirm(newVal, oldVal) {
            if (newVal === true) {
                this.$nextTick(() => {
                    this.$refs.confirm_0.focus();
                    this.confirmIndex = 0;
                });
            }
        }
    },
    mounted() {
        this.getConfigByCodes().then(() => {
            this.init();
        });
    },
    computed: {
        // 是否加锁
        isLock() {
            return this.hasLock && [2, 3, 5].includes(this.type * 1);
        },
        // 列表数据最后一行下标
        lastRowIndex() {
            return Array.isArray(this.dataList) ? this.dataList.length - 1 : 0;
        }
    },
    filters: {
        AutoSeriseTextSplit(x) {
            if (~x.indexOf(',')) {
                return x.split(',').join('<br/>');
            } else {
                return x;
            }
        }
    },
    directives: {
        //用户选择栏的懒加载
        scrollLoad: {
            bind(el, binding, vnode) {
                //防抖函数
                function debounce(func, wait, immediate) {
                    //func函数，wait为时间周期
                    var timeout;
                    return function () {
                        var context = this,
                            args = arguments;
                        var later = function () {
                            timeout = null;
                            if (!immediate) {
                                func.apply(context, args);
                            }
                        };
                        var callNow = immediate && !timeout;
                        clearTimeout(timeout);
                        timeout = setTimeout(later, wait);
                        if (callNow) {
                            func.apply(context, args);
                        }
                    };
                }
                let wrapDom = el.querySelector('.el-autocomplete-suggestion__wrap');
                let listDom = el.querySelector('.el-autocomplete-suggestion__wrap  .el-autocomplete-suggestion__list');
                //将滚动事件通过参数传入防抖函数中
                var myEfficientFn = debounce(function () {
                    let condition = wrapDom.offsetHeight + wrapDom.scrollTop + 10 - listDom.offsetHeight;
                    if (condition > 0 && !vnode.context.loading) {
                        //滚动到底部则执行滚动方法load，binding.value就是v-scrollLoad绑定的值，加()表示执行绑定的方法
                        binding.value();
                    }
                }, 250);
                wrapDom.addEventListener('scroll', myEfficientFn, false); //绑定滚动事件
            }
        }
    },
    methods: {
        init() {
            this.permission = this.$util.getPermission('salesOrder');
            this.id = this.$route.query.id;
            this.submitData.QuoteId = this.$route.query.id;
            this.type = this.$route.query.type;
            let salesbjOrder = this.$util.getLocalStorage('salesbjOrder');
            let datalist = this.$util.getLocalStorage('salesbjOrder_dataList');
            if (this.type == 0) {
                this.pageTitle = '新增报价单';
                //判断缓存是否有数据，如果有取缓存数据
                if (salesbjOrder && datalist && datalist.length > 0) {
                    this.getDataFromChace();
                } else {
                    this.getdefaultWarehouses();
                }
                if (this.$refs.cusselect) this.$refs.cusselect.focus();
            } else if (this.type == 1) {
                this.pageTitle = '查看报价单';
                this.dataReadonly = true;
                this.getBJOrder();
            } else if (this.type == 2) {
                this.pageTitle = '编辑报价单';
                if (salesbjOrder && datalist && datalist.length > 0) {
                    this.getDataFromChace();
                } else {
                    this.getBJOrder();
                }
            } else if (this.type == 3) {
                this.pageTitle = '新增报价单';
                if (salesbjOrder && datalist && datalist.length > 0) {
                    this.getDataFromChace();
                } else {
                    this.getdefaultWarehouses();
                    if (this.$refs.cusselect) this.$refs.cusselect.focus();
                    this.addItem(false);
                }
            } else if (this.type == 4) {
                this.pageTitle = '销售转报价单';
                if (salesbjOrder && datalist && datalist.length > 0) {
                    this.getDataFromChace();
                } else {
                    this.submitData.OId = this.$route.query.sid;
                    this.getSalesOrder();
                }
            } else if (this.type == 5) {
                this.pageTitle = '复制订单';
                if (salesbjOrder && datalist && datalist.length > 0) {
                    this.getDataFromChace();
                } else {
                    this.getBJOrder();
                }
            } else if (this.type == 6) {
                this.pageTitle = '销售退货转报价';
                if (salesbjOrder && datalist && datalist.length > 0) {
                    this.getDataFromChace();
                } else {
                    this.submitData.OId = this.$route.query.rid;
                    this.getSaleRetrunOrder();
                }
            }
            //当表格出现滚动条后，编辑最后一条数据时，点击滚动条内底部的空白处单元格的编辑状态没有去除
            //为了解决这个bug在表格的父级监听点击事件来清除单元格激活状态
            let tablebody = document.querySelector('.elx-table--body-wrapper');
            if (tablebody) tablebody.addEventListener('click', this.clearActived, false);
        },
        handleKeyEvent(e) {
            let that = this;
            if (that.dataReadonly) return;
            let key = window.event.keyCode;

            if (key === 107) {
                if (!that.searchVisible) that.addItem(false);
                return;
            }
            if (key == 112) {
                e.preventDefault();
                that.goback();
                return;
            }
            if (key == 113) {
                e.preventDefault();
                if (!that.searchVisible) {
                    that.resetSearch();
                    that.searchVisible = true;
                    that.hideMsg();
                    that.showResultFunc();
                    if (that.rowVisible) {
                        that.isStartConfirm = false;
                        that.rowVisible = false;
                    }
                }
                that.isStartSearch = true;
                return;
            }
            if (key == 114) {
                e.preventDefault();
                if (!that.APMsgVisible) that.showAPMsgDialog();
                return;
            }
            if (key == 115) {
                e.preventDefault();
                if (!that.historyQuoteVisible) that.showHistories();
                return;
            }
            if (key == 116) {
                e.preventDefault();
                if (!that.historyVisible) that.showHistoryDialog();
                return;
            }
            if (key == 117) {
                e.preventDefault();
                if (!that.historyPurVisible) that.showPurHistories();
                return;
            }
            if (key == 118) {
                if (that.permission.AddLogistics) {
                    e.preventDefault();
                    that.lceHandle(1);
                }

                return;
            }
            if (key == 119) {
                if (that.submitData.LogisticId && that.permission.EditLogistics) {
                    e.preventDefault();
                    if (that.submitData.LogisticId) that.lceHandle(2);
                }
                return;
            }
            if (key == 120) {
                //F9
                if (that.permission.addCustomer) {
                    e.preventDefault();
                    that.addCustomer(1);
                }

                return;
            }
            if (key == 121) {
                //F10
                if (that.permission.editCustomer && that.submitData.EntpCusId) {
                    e.preventDefault();
                    if (that.submitData.EntpCusId) that.addCustomer(2);
                }
                return;
            }
            if (key == 122) {
                //F11
                // if (!(that.permission.save)) return;
                // if (
                //     !that.dialogCusVisible &&
                //     !that.historyVisible &&
                //     !that.historyPurVisible &&
                //     !that.historyQuoteVisible &&
                //     !that.inqHistoryVisible &&
                //     !that.addAPVisible &&
                //     !that.tableSetsVisible &&
                //     !that.jointSetVisible &&
                //     !that.APMsgVisible
                // ) {
                //     e.preventDefault();
                //     that.submitForm();
                //     return;
                // }
                e.preventDefault();
                return;
            }
            if (key == 123) {
                //F12
                if (
                    !that.dialogCusVisible &&
                    !that.historyVisible &&
                    !that.historyPurVisible &&
                    !that.historyQuoteVisible &&
                    !that.inqHistoryVisible &&
                    !that.addAPVisible &&
                    !that.tableSetsVisible &&
                    !that.jointSetVisible &&
                    !that.APMsgVisible
                ) {
                    e.preventDefault();
                    that.submitForm();
                    return;
                }
                return;
            }
            if (key === 13) {
                //Enter
                if (
                    !that.dialogCusVisible &&
                    !that.historyVisible &&
                    !that.historyPurVisible &&
                    !that.historyQuoteVisible &&
                    !that.inqHistoryVisible &&
                    !that.addAPVisible &&
                    !that.tableSetsVisible &&
                    !that.jointSetVisible &&
                    !that.APMsgVisible
                ) {
                    e.preventDefault();
                    if (!that.searchVisible && that.currentRow && that.currentRow.EntpTempGoodsId) {
                        if (!that.rowVisible) {
                            that.dblChooseAps(that.currentRow);
                            if (that.searchVisible) {
                                that.searchVisible = false;
                                that.isStartSearch = false;
                            }
                        } else {
                            if (!that.rowFormLoading) that.rowConfirm();
                        }
                    } else if (
                        that.searchVisible &&
                        !that.rowVisible &&
                        that.$refs.search_5 &&
                        !that.$refs.search_5.visible &&
                        that.$refs.search_6 &&
                        !that.$refs.search_6.visible &&
                        that.canSearch
                    )
                        that.handleSearch();
                    that.canSearch = true;
                }
                return;
            }
            if (key === 27) {
                that.canSearch = true;
                that.showViewer = false;
                that.imageVisible = false;
                if ((that.$refs.search_2 && that.$refs.search_2.suggestionVisible) || (that.$refs.search_3 && that.$refs.search_3.suggestionVisible)) {
                    if (that.$refs.search_2 && that.$refs.search_2.suggestionVisible) that.$refs.search_2.suggestions = [];
                    if (that.$refs.search_3.suggestionVisible) that.$refs.search_3.suggestions = [];
                    return;
                }
                //ESC
                if (
                    !that.dialogCusVisible &&
                    !that.historyVisible &&
                    !that.historyPurVisible &&
                    !that.historyQuoteVisible &&
                    !that.inqHistoryVisible &&
                    !that.addAPVisible &&
                    !that.tableSetsVisible &&
                    !that.jointSetVisible &&
                    !that.APMsgVisible
                ) {
                    e.preventDefault();
                    if (that.searchVisible && !that.rowVisible) {
                        that.searchVisible = false;
                        that.isStartSearch = false;
                    } else if (!that.searchVisible && that.rowVisible) {
                        that.rowVisible = false;
                        that.isStartConfirm = false;
                    }
                    if (that.APMsgVisible) that.APMsgVisible = false;
                }
                return;
            }
            //下键
            if (key == 40) {
                that.canSearch = true;
                if (
                    !that.dialogCusVisible &&
                    !that.historyVisible &&
                    !that.historyPurVisible &&
                    !that.historyQuoteVisible &&
                    !that.inqHistoryVisible &&
                    !that.addAPVisible &&
                    !that.tableSetsVisible &&
                    !that.jointSetVisible &&
                    !that.APMsgVisible &&
                    !that.showViewer
                ) {
                    e.preventDefault();
                    if (!that.rowVisible && !that.searchVisible) {
                        if (that.dataindex != that.tableDataLength - 1) {
                            if (that.currentRow && that.currentRow.EntpTempGoodsId) {
                                that.dataindex++;
                            } else that.dataindex = 0;
                            let index = that.dataindex;
                            that.$nextTick(() => {
                                if (that.$refs.multipleTable) {
                                    that.currentRow = that.$refs.multipleTable.data[index];
                                    that.$refs.multipleTable.setCurrentRow(that.$refs.multipleTable.data[index]);
                                    that.$refs.multipleTable.scrollToRow(that.tableData[that.dataindex + 4]);
                                    that.$refs.multipleTable.scrollToRow(that.$refs.multipleTable.data[index]);
                                    that.getInvenDatas(that.currentRow);
                                }
                            });
                            if (that.dataindex > that.tableData.length - 10 && !that.searchLoading && that.dataindex < that.tableDataLength - 14) that.downKeyToLoad();
                        }
                    } else if (!that.rowVisible && that.searchVisible) {
                        if (that.searchIndex != 10) {
                            if (
                                (!that.$refs.search_5 || !that.$refs.search_5.visible) &&
                                (!that.$refs.search_6 || !that.$refs.search_6.visible) &&
                                (!that.$refs.search_2 || !that.$refs.search_2.suggestionVisible) &&
                                (!that.$refs.search_3 || !that.$refs.search_3.suggestionVisible)
                            ) {
                                if (that.searchIndex == 5 || that.searchIndex == 6) {
                                    if (that.$refs[`search_` + that.searchIndex]) that.$refs[`search_` + that.searchIndex].blur();
                                }
                                that.searchIndex += 1;
                                if (that.$refs[`search_` + that.searchIndex]) that.$refs[`search_` + that.searchIndex].focus();
                            }
                        }
                    } else if (that.rowVisible && !that.searchVisible) {
                        if (that.confirmIndex != 2) {
                            that.confirmIndex += 1;
                            if (that.$refs[`confirm_` + that.confirmIndex]) that.$refs[`confirm_` + that.confirmIndex].focus();
                        }
                    }
                    return;
                }
                return;
            }
            //上键
            if (key == 38) {
                that.canSearch = true;
                if (
                    !that.dialogCusVisible &&
                    !that.historyVisible &&
                    !that.historyQuoteVisible &&
                    !that.historyPurVisible &&
                    !that.inqHistoryVisible &&
                    !that.addAPVisible &&
                    !that.tableSetsVisible &&
                    !that.jointSetVisible &&
                    !that.APMsgVisible &&
                    !that.showViewer
                ) {
                    e.preventDefault();
                    if (!that.rowVisible && !that.searchVisible) {
                        if (that.dataindex != 0) {
                            that.dataindex--;
                            let index = that.dataindex;
                            that.$nextTick(() => {
                                if (that.$refs.multipleTable) {
                                    that.currentRow = that.$refs.multipleTable.data[index];
                                    that.$refs.multipleTable.setCurrentRow(that.$refs.multipleTable.data[index]);
                                    that.$refs.multipleTable.scrollToRow(that.tableData[that.dataindex - 5]);
                                    that.getInvenDatas(that.currentRow);
                                }
                            });
                        }
                    } else if (!that.rowVisible && that.searchVisible) {
                        if (that.searchIndex != 0) {
                            if (
                                (!that.$refs.search_5 || !that.$refs.search_5.visible) &&
                                (!that.$refs.search_6 || !that.$refs.search_6.visible) &&
                                (!that.$refs.search_2 || !that.$refs.search_2.suggestionVisible) &&
                                (!that.$refs.search_3 || !that.$refs.search_3.suggestionVisible)
                            ) {
                                if (that.searchIndex == 5 || that.searchIndex == 6) {
                                    if (that.$refs[`search_` + that.searchIndex]) that.$refs[`search_` + that.searchIndex].blur();
                                }
                                that.searchIndex -= 1;
                                if (that.$refs[`search_` + that.searchIndex]) that.$refs[`search_` + that.searchIndex].focus();
                            }
                        }
                    } else if (that.rowVisible && !that.searchVisible) {
                        if (that.confirmIndex != 0) {
                            that.confirmIndex -= 1;
                            if (that.$refs[`confirm_` + that.confirmIndex]) that.$refs[`confirm_` + that.confirmIndex].focus();
                        }
                    }
                    return;
                }
                return;
            }
        },
        goback() {
            this.$router.push('/salesManage/quotation');
        },
        getConfigByCodes() {
            return new Promise(resolve => {
                let codes = [
                    'kdbjsd',
                    'ddhhm',
                    'kdyjz',
                    'xskbzb',
                    'xsspjgwl',
                    'xgxsjg',
                    'lybsdr',
                    'xskdxskdj',
                    'xskdxskdbm',
                    'kdspcd',
                    'kdspgg',
                    'xskdmrcdpx',
                    'kdmrpppx',
                    'kdxspp',
                    'ygsfkzdylb',
                    'xzqpbmdwyx',
                    'kcspssyq'
                ];
                this.$util.getSysConfigs(codes).then(data => {
                    if (data) {
                        for (let i = 0; i < data.length; i++) {
                            let code = data[i].Code;
                            let result = data[i].Result;
                            let rValue = data[i].RValue;
                            switch (code) {
                                case 'kdbjsd':
                                    this.hasLock = result;
                                    break;
                                case 'ddhhm':
                                    this.changeCodeConfig = result;
                                    break;
                                case 'kdyjz':
                                    this.isPreloadApCodeList = result;
                                    break;
                                case 'xskbzb':
                                    this.LoseMoneyValue = result ? Number(rValue) : 0;
                                    break;
                                case 'xsspjgwl':
                                    this.priceCanBeZero = result;
                                    break;
                                case 'xgxsjg':
                                    this.priceCanBeEdit = result;
                                    break;
                                case 'lybsdr':
                                    this.isAddWaitIn = !result;
                                    break;
                                case 'xskdxskdj':
                                    this.isBPriceShow = result;
                                    break;
                                case 'xskdxskdbm':
                                    this.isOrgShow = result;
                                    break;
                                case 'kcspssyq': //使用搜索引擎
                                    this.isUseSE = result;
                                    break;
                                case 'kdspcd': //是否出现产地
                                    this.isOriginShow = result;
                                    break;
                                case 'kdspgg': //是否出现规格
                                    this.isSizeShow = result;
                                    break;
                                case 'xskdmrcdpx': //是否默认产地排序
                                    this.isOriginSort = result;
                                    break;
                                case 'kdmrpppx': //是否默认品牌排序
                                    this.isBrandSort = result;
                                    break;
                                case 'kdxspp': //是否显示品牌
                                    this.isShowBrand = result;
                                    break;
                                case 'ygsfkzdylb': //是否可自定义列表
                                    this.isCanTBSet = result;
                                    break;
                                case 'xzqpbmdwyx': //是否检测编码重复
                                    this.isCheckCode = result;
                                    break;
                            }
                        }
                    }
                    resolve();
                });
            });
        },
        change(e, type) {
            let that = this;
            if (!that.rowVisible) {
                let fIdx = that.dataList.findIndex(f => f.EntpTempGoodsId === that.currentRow.EntpTempGoodsId);
                if (fIdx > -1) {
                    that.dataList[fIdx].BillingPrice = that.rowForm._biilPrice;
                    that.dataList[fIdx].Count = that.rowForm._count;
                    that.dataList[fIdx].MarketPrice = that.rowForm._price;
                }
            } else {
                if (type === 1) that.rowForm._biilPrice = e;
            }
        },
        // 编码排序
        changeTableSort(type, prop) {
            let sortArr = [];
            let listArr = this.dataList.filter(f => f[prop]);
            let otherArr = this.dataList.filter(f => !f[prop]);
            if (type === 'top') {
                this.sortActive = 'top';
                sortArr = listArr.sort((a, b) => a[prop].localeCompare(b[prop]));
            } else {
                this.sortActive = 'bottom';
                sortArr = listArr.sort((a, b) => b[prop].localeCompare(a[prop]));
            }
            this.dataList = [...sortArr, ...otherArr];
        },
        showAddAPDialog() {
            this.addAPVisible = true;
        },
        // 关闭新增库存弹框
        async closeAddAPDialog(result, row) {
            let that = this;
            if (!row) {
                that.addAPVisible = false;
                return;
            } else {
                //移除最后一个空的配件
                if (that.dataList.length > 0 && !that.dataList[that.dataList.length - 1].EntpTempGoodsId) {
                    that.dataList.splice(that.dataList.length - 1, 1);
                }
                that.dataList.push({
                    ...row,
                    Count: that.initNumber,
                    canEdit: true,
                    State: 0,
                    StorageInventory: 0,
                    OrderWaitOutQuantity: 0,
                    POrderWaitInQuantity: 0,
                    // BillingPrice: 0
                    BillingPrice: row.MarketPrice
                });
                that.addAPVisible = false;
                this.addPageChace();
            }
            this.priceChange();
        },
        // 自动选中输入框内容
        selectAutoHandle(ref) {
            clearTimeout(this.timer);
            //每次点击搜索配件后打开弹窗，select()事件没效果，有可能初始化控件后这个事件还没监听到input控件
            //所以这里用来nextTick 和 setTimeout做双重保证
            this.$nextTick(() => {
                // this.$refs[ref].select();
                this.timer = setTimeout(() => {
                    if (this.$refs[ref]) this.$refs[ref].select();
                }, 100);
            });
        },
        getConfigData() {
            this.$util.searchGoodsUnit().then(res => {
                this.unitList = res;
            });
        },
        // 搜索
        showSearch() {
            this.resetSearch();
            this.searchVisible = true;
            this.isStartSearch = true;
            this.showResultFunc();
            this.hideMsg();
        },
        closeSearchDialog() {
            // this.searchVisible = false;
            this.isStartSearch = false;
        },
        chooseAllAPsHandle() {
            let that = this;
            that.$confirm('是否将查询结果全部加入到订单商品明细中？', '', {
                type: 'warning',
                distinguishCancelAndClose: true
            })
                .then(() => {
                    this.searchApParams = {
                        ...this.searchData,
                        limit: this.searchApParams._limit,
                        _visible: true,
                        _percentage: 0,
                        _limit: this.searchApParams._limit,
                        _totalCount: this.tableDataLength
                    };
                    //当查询结果出来后，用过有可能加载下一页数据，所以全部加入订单时要重置页码
                    this.searchApParams.page = 1;
                    this.loopSearch();
                })
                .catch(() => {});
        },
        // 开始循环
        async loopSearch() {
            let url = '';

            if (this.isUseSE) url = '/api/EntpGoods/GetGoodsListFromSE';
            else url = '/api/EntpGoods/GetGoodsListForEditOrder_V3';

            const { data } = await this.$util.axiosPost({
                url: url,
                data: this.searchApParams,
                hideLoading: true
            });
            this.searchApParams._percentage = parseInt(((this.searchApParams.page * this.searchApParams.limit) / this.searchApParams._totalCount) * 100);

            this.searchApParams.page += 1;
            let _stop = !data || data.length < this.searchApParams._limit;
            this.addToList(data);
            if (_stop) {
                this.searchApParams._percentage = 100;
                this.searchApParams._visible = false;
            } else {
                this.loopSearch();
            }
        },
        addToList(items) {
            let that = this;
            let itemList = [...items];
            let newGoodsList = [];
            for (let i = 0; i < itemList.length; i++) {
                let item = itemList[i];
                let isExist = false;
                that.dataList.forEach((e, index) => {
                    if (item.EntpTempGoodsId == e.EntpTempGoodsId) {
                        isExist = true;
                        e.StorageInventory = item.StorageInventory;
                        e.MarketPrice = item.LatestPrice > 0 ? item.LatestPrice : '';
                    }
                });
                if (!isExist) {
                    let newGoods = {
                        ReferencePrice: item.ReferencePrice,
                        EntpTempGoodsId: item.EntpTempGoodsId,
                        APCode: item.APCode,
                        GoodName: item.GoodName,
                        GoodNameItem: item.GoodName,
                        AutoSerise: item.AutoSerise,
                        AutoSeriseItem: item.AutoSerise,
                        Count: this.initNumber,
                        MarketPrice: item.MarketPrice,
                        Unit: item.Unit,
                        Origin: item.Origin,
                        Remark: '',
                        CodeRepeat: false,
                        Inventory: item.Inventory,
                        StorageInventory: item.StorageInventory,
                        WarehousedCount: 0,
                        OrderWaitOutQuantity: item.OrderWaitOutQuantity,
                        POrderWaitInQuantity: item.POrderWaitInQuantity,
                        LatestSalesTime: item.LatestSalesTime,
                        LatestQuoteTime: item.LatestQuoteTime,
                        State: 0,
                        canEdit: true,
                        IntenCount: item.IntenCount,
                        CostPrice: item.CostPrice,
                        BillingPrice: item.MarketPrice == 0 ? '' : item.MarketPrice,
                        Size: item.Size,
                        Brand: item.Brand
                    };
                    if (!isNaN(item._count)) {
                        newGoods.Count = item._count;
                    }
                    if (!isNaN(item._price)) {
                        newGoods.MarketPrice = item._price;
                    }
                    newGoodsList.push(newGoods);
                }
            }
            //判断最后一条数据是否空值，是的话移到最后，noClose 表示不关闭弹框
            if (that.dataList.length == 0) {
                that.dataList = that.dataList.concat(newGoodsList);
            } else {
                let lastItem = that.dataList[that.dataList.length - 1];
                if (!lastItem.APCode && !lastItem.GoodName) {
                    that.dataList.splice(that.dataList.length - 1, 1);
                    that.dataList = that.dataList.concat(newGoodsList);
                    that.dataList.push(lastItem);
                } else {
                    that.dataList = that.dataList.concat(newGoodsList);
                }
            }
            that.priceChange();
            that.addPageChace();
        },
        getGoodsBrand() {
            if (this.brandList.length > 0) return;
            this.loading = true;
            this.$util
                .searchGoodsBrand()
                .then(data => {
                    this.brandList = data;
                    this.loading = false;
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        getGoodsType() {
            if (this.typeList.length > 0) return;
            this.loading = true;
            this.$util
                .searchGoodsType()
                .then(data => {
                    this.typeList = data;
                    this.loading = false;
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        tableRowClassName({ row, rowIndex }) {
            //把每一行的索引放进row
            row.index = rowIndex;
        },
        rowClick(row, column, event) {
            let that = this;
            that.dataindex = row.index;
            that.currentRow = row;
            that.getInvenDatas(row);
        },
        getInvenDatas(row) {
            let that = this;
            that.$util
                .axiosGet({
                    url: '/api/EntpGoods/GetGoodsStorageInvens',
                    data: {
                        GoodsId: row.EntpTempGoodsId
                    },
                    hideLoading: true
                })
                .then(res => {
                    let data = res.data;
                    if (!data) {
                        return;
                    }
                    that.isShowSummary = true;
                    that.summaryList = data;
                })
                .catch(() => {});
        },
        // 列表双击打开弹框
        dblChooseAps(e) {
            let that = this;
            //先获取一些数据
            if ([e][0]) {
                that.rowFormLoading = true;
                that.rowVisible = true;
                that.isStartConfirm = true;
                that.$util.getGoodsDataForConfirm_V3(e.EntpTempGoodsId, '', that.submitData.EntpCusId, '0').then(data => {
                    if (data) {
                        that.rowForm = {
                            ...[e][0],
                            _price: data.LatestPrice,
                            _biilPrice: data.LatestPrice,
                            _count: 1,
                            _referencePrice: data.ReferencePrice ? data.ReferencePrice : e.MarketPrice
                        };
                    }
                    that.selectAutoHandle('confirm_0');
                    that.rowFormLoading = false;
                });
            }
        },
        rowConfirm() {
            let that = this;
            let item = that.rowForm;
            let sIdx = that.tableData.findIndex(f => f.EntpTempGoodsId === item.EntpTempGoodsId);
            if (sIdx > -1) {
                that.tableData[sIdx].IsSelected = true;
            }
            let fIdx = that.dataList.findIndex(f => f.EntpTempGoodsId === item.EntpTempGoodsId);
            if (fIdx > -1) {
                that.dataList[fIdx].Count = item._count;
                that.dataList[fIdx].MarketPrice = item._price;
                that.dataList[fIdx].BillingPrice = item._biilPrice;
            } else {
                let newGoods = {};
                newGoods = {
                    ReferencePrice: item.ReferencePrice,
                    EntpTempGoodsId: item.EntpTempGoodsId,
                    APCode: item.APCode,
                    GoodName: item.GoodName,
                    GoodNameItem: item.GoodName,
                    AutoSerise: item.AutoSerise,
                    AutoSeriseItem: item.AutoSerise,
                    Count: item._count,
                    MarketPrice: item._price,
                    Unit: item.Unit,
                    Remark: '',
                    CodeRepeat: false,
                    Inventory: item.Inventory,
                    StorageInventory: item.StorageInventory,
                    WarehousedCount: 0,
                    OrderWaitOutQuantity: item.OrderWaitOutQuantity,
                    POrderWaitInQuantity: item.POrderWaitInQuantity,
                    LatestSalesTime: item.LatestSalesTime,
                    LatestQuoteTime: item.LatestQuoteTime,
                    State: 0,
                    canEdit: true,
                    IntenCount: item.IntenCount,
                    CostPrice: item.CostPrice,
                    BillingPrice: item._biilPrice,
                    Origin: item.Origin,
                    Size: item.Size,
                    Brand: item.Brand
                };
                that.dataList.push(newGoods);
            }
            that.addPageChace();
            that.priceChange();
            that.rowVisible = false;
            that.isStartConfirm = false;
        },
        rowClose() {
            this.rowVisible = false;
            this.isStartConfirm = false;
            this.rowForm = {};
        },
        showIntentDatas(id) {
            if (id) {
                if (this.inqHistoryVisible) {
                    this.$refs.APInquiryHistory.updateTableData(id);
                } else {
                    this.hisGoodsId = id;
                    this.inqHistoryVisible = true;
                }
            }
        },
        showNeedInData(item) {
            if (item.EntpTempGoodsId && !this.needInDataVisible) {
                this.EntpTempGoodsId = item.EntpTempGoodsId;
                this.NeedITitle = '【配件待入数据】配件编码：' + item.APCode + ' —— 配件名称：' + item.GoodName;
                this.needInDataVisible = true;
            } else if (item.EntpTempGoodsId && this.needInDataVisible) {
                this.$refs.APNeedInDatas.updateTableData(item.EntpTempGoodsId);
            }
        },
        showNeedOutData(item) {
            if (item.EntpTempGoodsId && !this.needOutDataVisible) {
                this.EntpTempGoodsId = item.EntpTempGoodsId;
                this.NeedOTitle = '【配件待出数据】配件编码：' + item.APCode + ' —— 配件名称：' + item.GoodName;
                this.needOutDataVisible = true;
            } else if (item.EntpTempGoodsId && this.needOutDataVisible) {
                this.$refs.APNeedOutDatas.updateTableData(item.EntpTempGoodsId);
            }
        },
        closeJointDialog() {
            this.jointSetVisible = false;
        },
        jointSets() {
            this.jointSetVisible = true;
        },
        sortChange(event) {
            this.searchData.SortProp = event.prop;
            this.searchData.SortType = event.order ? event.order : '';
            if (this.searchData.SortType == '') this.searchData.SortProp = '';
            this.searchData.page = 1;
            this.dataindex = -1;
            this.tableData = [];
            this.scrollTop = 0;
            this.scrollLeft = 0;
            this.getAPTableData();
        },
        // 配件信息
        showAPMsgDialog(id) {
            let that = this;
            if (id) {
                this.EntpTempGoodsIdEdit = id;
                this.APMsgVisible = true;
            } else if (that.currentRow && that.currentRow.EntpTempGoodsId) {
                this.EntpTempGoodsIdEdit = that.currentRow.EntpTempGoodsId;
                this.APMsgVisible = true;
            }
        },
        closeAPMsgDialog(edit) {
            this.APMsgVisible = false;
            if (edit) {
                this.getOrderDetail();
            }
        },
        // 历史销售
        showHistoryDialog() {
            let that = this;
            if (that.currentRow && that.currentRow.EntpTempGoodsId) {
                this.EntpTempGoodsIdEdit = that.currentRow.EntpTempGoodsId;
                this.historyVisible = true;
            }
        },
        closeHistoryDialog(edit) {
            this.historyVisible = false;
            this.historyQuoteVisible = false;
            this.historyPurVisible = false;
        },
        //历史报价
        showHistories() {
            let that = this;
            if (that.currentRow && that.currentRow.EntpTempGoodsId) {
                this.EntpTempGoodsIdEdit = that.currentRow.EntpTempGoodsId;
                this.historyQuoteVisible = true;
            }
        },
        //历史采购
        showPurHistories() {
            let that = this;
            if (that.currentRow && that.currentRow.EntpTempGoodsId) {
                this.EntpTempGoodsIdEdit = that.currentRow.EntpTempGoodsId;
                this.historyPurVisible = true;
            }
        },
        // 配件信息
        hideMsg() {
            this.showOrderMsg = false;
            if (this.$refs.cusselect) this.$refs.cusselect.blur();
        },
        showMsg() {
            this.showOrderMsg = true;
        },
        hideResultFunc() {
            this.showResultMsg = false;
        },
        showResultFunc() {
            this.showResultMsg = true;
        },
        // 数量或者价格变动
        priceChange() {
            let DetailList = this.dataList;
            let _allNum = 0;
            let _allMoney = 0;
            for (let i = 0; i < DetailList.length; i++) {
                _allNum += Number(DetailList[i].Count);
                _allMoney += Number(DetailList[i].Count * DetailList[i].MarketPrice ? (DetailList[i].Count * DetailList[i].MarketPrice).toFixed(3) : 0);
            }
            this.allMoney = _allMoney.toFixed(2);
            this.allNum = _allNum;
        },
        //检查是否亏本
        CheckLoseMoney(costPrice, salePric) {
            let that = this;
            if (!that.LoseMoneyValue || !costPrice || !salePric) return false;

            let val = Number(salePric) * ((100 - that.LoseMoneyValue) / 100) < Number(costPrice);
            return val;
        },
        // closeDialog(edit, id, name) {
        //     if (edit) {
        //         if (id) {
        //             let currCust = this.customerList.find(e => e.EntpCusId == id);
        //             if (currCust) {
        //                 this.submitData.EntpCusName = name;
        //                 currCust.EntpCusName = name;
        //                 this.submitData.EntpCusId = '';
        //             }
        //             this.$nextTick(() => {
        //                 this.submitData.EntpCusId = id;
        //             });
        //         } else {
        //             this.searchCustomer();
        //         }
        //     }
        //     this.tableSetsVisible = false;
        //     this.dialogVisible = false;
        // },
        closeDialog(edit, id, name) {
            let that = this;
            if (edit) {
                if (id) {
                    let currCust = that.customerList.find(e => e.EntpCusId == id);
                    if (!currCust) {
                        that.customerList.push({
                            EntpCusId: id,
                            EntpCusName: name
                        });
                    } else {
                        that.submitData.EntpCusName = name;
                        currCust.EntpCusName = name;
                        that.submitData.EntpCusId = '';
                    }

                    that.$nextTick(() => {
                        that.submitData.EntpCusId = id;
                        if (!that.submitData.EntpCusName) that.submitData.EntpCusName = name;
                    });
                } else {
                    that.searchCustomer();
                }
            }
            that.tableSetsVisible = false;
            that.dialogVisible = false;
        },
        addCustomer(type) {
            this.customerEditType = type;
            this.dialogVisible = true;
        },
        customerChange(value) {
            let that = this;
            if (!value) that.submitData.EntpCusName = '';
            else {
                let currCust = that.customerList.find(e => e.EntpCusId == value);
                if (currCust) {
                    that.submitData.EntpCusName = currCust.EntpCusName;
                }
            }
        },
        //获取销售转报价单的数据
        getSalesOrder() {
            this.$util
                .axiosGet({
                    url: '/api/EntpSaleOrder/GetOrderforQuote',
                    data: {
                        EntpCusOId: this.submitData.OId
                    }
                })
                .then(res => {
                    let data = res.data;
                    this.customerList.push({
                        EntpCusId: data.EntpCusId,
                        EntpCusName: data.EntpCusName
                    });

                    this.submitData = data;
                    if (data.Warehouse) {
                        this.warehouseList.push({
                            WarehouseId: data.Warehouse.WarehouseId,
                            WarehouseName: data.Warehouse.WarehouseName,
                            Type: data.Warehouse.Type
                        });
                        this.warehouseType = data.Warehouse.Type;
                        this.$set(this.submitData, 'WarehouseId', data.Warehouse.WarehouseId);
                        this.$set(this.submitData, 'WarehouseType', data.Warehouse.Type);
                        this.$set(this.submitData, 'WarehouseName', data.Warehouse.WarehouseName);
                    }

                    let DetailList = data.DetailList;
                    let _allNum = 0;
                    let _allMoney = 0;
                    for (let i = 0; i < DetailList.length; i++) {
                        _allNum += Number(DetailList[i].Count);
                        _allMoney += DetailList[i].Count * DetailList[i].MarketPrice ? DetailList[i].Count * DetailList[i].MarketPrice : 0;
                        DetailList[i].GoodNameItem = DetailList[i].GoodName;
                        DetailList[i].AutoSeriseItem = DetailList[i].AutoSerise;
                        DetailList[i].hasLock = this.hasLock;
                    }

                    this.allMoney = _allMoney.toFixed(2);
                    this.allNum = _allNum;
                    this.dataList = DetailList;
                });
        },
        //获取询价单详情
        getBJOrder() {
            this.$util
                .axiosGet({
                    url: '/api/EntpQuotationOrder/GetQuotationOrder',
                    data: {
                        QuoteId: this.id
                    }
                })
                .then(res => {
                    let data = res.data;
                    data.QuoteId = this.id;
                    this.customerList.push({
                        EntpCusId: data.EntpCusId,
                        EntpCusName: data.EntpCusName
                    });
                    this.submitData = data;
                    if (data.Warehouse) {
                        this.warehouseList.push({
                            WarehouseId: data.Warehouse.WarehouseId,
                            WarehouseName: data.Warehouse.WarehouseName,
                            Type: data.Warehouse.WarehouseType
                        });
                        this.warehouseType = data.Warehouse.WarehouseType;
                        this.$set(this.submitData, 'WarehouseId', data.Warehouse.WarehouseId);
                        this.$set(this.submitData, 'WarehouseType', data.Warehouse.WarehouseType);
                        this.$set(this.submitData, 'WarehouseName', data.Warehouse.WarehouseName);
                    }

                    let DetailList = data.DetailList;
                    let _allNum = 0;
                    let _allMoney = 0;
                    for (let i = 0; i < DetailList.length; i++) {
                        _allNum += Number(DetailList[i].Count);
                        _allMoney += DetailList[i].Count * DetailList[i].MarketPrice ? DetailList[i].Count * DetailList[i].MarketPrice : 0;
                        DetailList[i].GoodNameItem = DetailList[i].GoodName;
                        DetailList[i].AutoSeriseItem = DetailList[i].AutoSerise;
                        DetailList[i].hasLock = this.hasLock;
                    }

                    this.allMoney = _allMoney.toFixed(2);
                    this.allNum = _allNum;
                    this.dataList = DetailList;
                });
        },
        //获取退货转报价单的数据
        getSaleRetrunOrder() {
            this.$util
                .axiosGet({
                    url: '/api/EntpSaleReturnOrder/GetOrderforQuote',
                    data: {
                        SReturnId: this.submitData.OId
                    }
                })
                .then(res => {
                    let data = res.data;
                    this.customerList.push({
                        EntpCusId: data.EntpCusId,
                        EntpCusName: data.EntpCusName
                    });
                    this.submitData = data;
                    if (data.Warehouse) {
                        this.warehouseList.push({
                            WarehouseId: data.Warehouse.WarehouseId,
                            WarehouseName: data.Warehouse.WarehouseName,
                            Type: data.Warehouse.WarehouseType
                        });
                        this.warehouseType = data.Warehouse.WarehouseType;
                        this.$set(this.submitData, 'WarehouseId', data.Warehouse.WarehouseId);
                        this.$set(this.submitData, 'WarehouseType', data.Warehouse.WarehouseType);
                        this.$set(this.submitData, 'WarehouseName', data.Warehouse.WarehouseName);
                    }
                    if (data.DetailList && data.DetailList.length > 0) {
                        let DetailList = data.DetailList;
                        let _allNum = 0;
                        let _allMoney = 0;
                        for (let i = 0; i < DetailList.length; i++) {
                            _allNum += Number(DetailList[i].Count);
                            _allMoney += DetailList[i].Count * DetailList[i].MarketPrice ? DetailList[i].Count * DetailList[i].MarketPrice : 0;
                            DetailList[i].GoodNameItem = DetailList[i].GoodName;
                            DetailList[i].AutoSeriseItem = DetailList[i].AutoSerise;
                            DetailList[i].BillingPrice = DetailList[i].MarketPrice;
                            DetailList[i].hasLock = this.hasLock;
                        }

                        this.allMoney = _allMoney.toFixed(2);
                        this.allNum = _allNum;
                        this.dataList = DetailList;
                    } else {
                        this.addItem();
                    }
                });
        },
        //添加页面缓存
        addPageChace() {
            this.removePageChace();
            this.$util.setLocalStorage('salesbjOrder', this.submitData);
            this.$util.setLocalStorage('salesbjOrder_dataList', this.dataList);
        },
        //清除页面缓存
        removePageChace() {
            this.$util.clearLocalStorage('salesbjOrder');
            this.$util.clearLocalStorage('salesbjOrder_dataList');
        },
        //从缓存中读取数据
        getDataFromChace() {
            let bjModel = this.$util.getLocalStorage('salesbjOrder');
            let datalist = this.$util.getLocalStorage('salesbjOrder_dataList');
            if (bjModel) {
                this.submitData = bjModel;
                let isexit = this.customerList.find(e => e.EntpCusId == bjModel.EntpCusId);
                if (!isexit) {
                    this.customerList.push({
                        EntpCusId: bjModel.EntpCusId,
                        EntpCusName: bjModel.EntpCusName
                    });
                }
            }
            if (bjModel.WarehouseId) {
                this.warehouseList.push({
                    WarehouseId: bjModel.WarehouseId,
                    WarehouseName: bjModel.WarehouseName,
                    Type: bjModel.WarehouseType
                });
                this.warehouseType = bjModel.WarehouseType;
                this.$set(this.submitData, 'WarehouseId', bjModel.WarehouseId);
                this.$set(this.submitData, 'WarehouseType', bjModel.WarehouseType);
                this.$set(this.submitData, 'WarehouseName', bjModel.WarehouseName);
            } else {
                this.getdefaultWarehouses();
            }
            let DetailList = datalist;
            let _allNum = 0;
            let _allMoney = 0;
            for (let i = 0; i < DetailList.length; i++) {
                _allNum += Number(DetailList[i].Count);
                _allMoney += DetailList[i].Count * DetailList[i].MarketPrice ? DetailList[i].Count * DetailList[i].MarketPrice : 0;
                DetailList[i].GoodNameItem = DetailList[i].GoodName;
                DetailList[i].AutoSeriseItem = DetailList[i].AutoSerise;
                DetailList[i].hasLock = this.hasLock;
            }

            this.allMoney = _allMoney.toFixed(2);
            this.allNum = _allNum;
            this.dataList = DetailList;
        },
        // 提交询价单
        submitForm() {
            if (this.saving) return;
            let _dataList = this.dataList;
            if (!this.submitData.EntpCusId) {
                this.$util.warningMsg('请选择客户');
                return;
            }
            if (this.submitData.PriceSumShip < 0) {
                this.$util.warningMsg('运费不能小于0');
                return;
            }
            for (let i = 0; i < _dataList.length; i++) {
                if (!_dataList[i].APCode) {
                    this.$util.warningMsg('请填写配件编码');
                    return;
                }
                if (!_dataList[i].GoodName) {
                    this.$util.warningMsg('请填写配件名称');
                    return;
                }
                if (_dataList[i].State != 0) {
                    this.$util.warningMsg('商品【' + _dataList[i].GoodName + '（' + _dataList[i].APCode + '）' + '】已删除');
                    return;
                }
                if (!_dataList[i].AutoSerise) {
                    this.$util.warningMsg('请填写车型');
                    return;
                }
                if (!_dataList[i].Unit) {
                    this.$util.warningMsg('请填写单位');
                    return;
                }
                if (_dataList[i].CostPrice && _dataList[i].CostPrice < 0) {
                    this.$util.warningMsg('进货价不能小于0');
                    return;
                }
                if (!_dataList[i].MarketPrice || Number(_dataList[i].MarketPrice) <= 0) {
                    this.$util.warningMsg(`请给序号为 ${i + 1} 的商品填写正确的销售价`);
                    return;
                }
            }
            this.submitData.DetailList = _dataList;

            let checkRepeat = this.checkRepeatAndReturnData();
            if (checkRepeat.hasRepeat) {
                this.$confirm('订单含有重复商品项，是否需要累加', '', {
                    type: 'error',
                    distinguishCancelAndClose: true
                })
                    .then(() => {
                        // 覆盖数据
                        this.dataList = checkRepeat.row;
                        this.submitData.DetailList = checkRepeat.row;
                        this.submitFormAgain();
                    })
                    .catch(() => {});
            } else {
                this.submitFormAgain();
            }
        },
        submitFormAgain() {
            this.saving = true;
            let url = '/api/EntpQuotationOrder/SaveQuotationOrder';
            if (+this.type == 4) url = '/api/EntpQuotationOrder/TransformSaleOrder';
            if (+this.type == 5) url = '/api/EntpQuotationOrder/RebuildEntpCustQOrder';
            if (+this.type == 6) url = '/api/EntpQuotationOrder/TransformSaleReturnOrder';
            this.$util
                .axiosPost({
                    url: url,
                    data: this.submitData
                })
                .then(res => {
                    if (res.errcode == 0) {
                        this.needConfirm = false;
                        this.$util.successMsg('提交报价单成功');
                        //清除订单缓存
                        this.removePageChace();
                        //编辑后列表页面需要刷新
                        this.$store.commit('updateNeedRefresh', true);
                        setTimeout(() => {
                            this.saving = false;
                            this.$router.push('/salesManage/quotation');
                        }, 2000);
                    }
                })
                .catch(() => {
                    this.saving = false;
                });
        },
        // 检查是否有重复项及返回已合并数量的数据
        checkRepeatAndReturnData() {
            let [list, row, hasRepeat] = [this.submitData.DetailList, [], false];
            if (this.isCheckCode) {
                list.forEach(item => {
                    let index = row.findIndex(f => f.APCode === item.APCode);
                    if (index > -1) {
                        hasRepeat = true;
                        row[index].Count = Number(row[index].Count) + Number(item.Count);
                    } else {
                        row.push(Object.assign({}, item));
                    }
                });
            } else {
                list.forEach(item => {
                    let index = row.findIndex(f => f.EntpTempGoodsId === item.EntpTempGoodsId);
                    if (index > -1) {
                        hasRepeat = true;
                        row[index].Count = Number(row[index].Count) + Number(item.Count);
                    } else {
                        row.push(Object.assign({}, item));
                    }
                });
            }
            return {
                hasRepeat,
                row
            };
        },
        // 删除某行
        delItem(index) {
            if (this.dataList.length != 1) {
                this.dataList.splice(index, 1);
            }
            this.addPageChace();
        },
        // 添加一行
        addItem(addPageChace) {
            if (this.dataReadonly) return;
            let _dataList = this.dataList;
            for (let i = 0; i < _dataList.length; i++) {
                if (!_dataList[i].APCode) {
                    this.$util.warningMsg('请填写配件编码');
                    return;
                }
                if (!_dataList[i].GoodName) {
                    this.$util.warningMsg('请填写配件名称');
                    return;
                }
                if (!_dataList[i].AutoSerise) {
                    this.$util.warningMsg('请填写车型');
                    return;
                }
                if (!_dataList[i].Unit) {
                    this.$util.warningMsg('请填写单位');
                    return;
                }
            }

            // 上锁
            if (this.isLock) {
                this.dataList.forEach(ele => {
                    ele.hasLock = true;
                });
            }
            if (addPageChace) {
                this.addPageChace(); //添加订单缓存
            }

            this.dataList.push({
                EntpTempGoodsId: '',
                APCode: '',
                GoodName: '',
                AutoSerise: '',
                Count: this.initNumber,
                ReferencePrice: '0',
                MarketPrice: '',
                CostPrice: '0',
                Unit: '',
                Remark: '',
                CodeRepeat: false,
                State: 0,
                Inventory: 0, //商品总数量
                StorageInventory: 0, //仓库库存数量
                OrderWaitOutQuantity: 0,
                POrderWaitInQuantity: 0,
                Brand: '',
                Origin: ''
            });
            this.priceChange();
            setTimeout(() => {
                this.$refs.infiniteTable.scrollToRow(this.dataList[this.dataList.length - 1]);
                this.$refs.infiniteTable.setActiveRow(this.dataList[this.dataList.length - 1]);
                if (this.dataList.length > 1) {
                    let ilEle = document.getElementsByClassName('business-content')[0];
                    ilEle.scrollTop = ilEle.scrollHeight;
                }
            }, 100);

            let that = this;
            that.$nextTick(() => {
                setTimeout(function () {
                    that.$refs.sapcode.focus();
                }, 200);
            });
        },
        // 解锁
        upLock(index) {
            this.$set(
                this.dataList,
                index,
                Object.assign({}, this.dataList[index], {
                    hasLock: !this.dataList[index].hasLock
                })
            );
        },
        // 点击展开下拉框
        focusHandle(type) {
            if (type === 'sapcode') {
                setTimeout(() => {
                    this.$refs[`sapcode`].focus();
                }, 200);
            }
            if (type === 'partsNameSelect') {
                setTimeout(() => {
                    this.$refs[`partsNameSelect`].focus();
                }, 200);
            }
            if (type === 'autoSeriseSelect') {
                setTimeout(() => {
                    this.$refs[`autoSeriseSelect`].focus();
                }, 200);
            }
            if (type === 'originRef') {
                setTimeout(() => {
                    this.$refs[`originRef`].focus();
                }, 200);
            }
            if (type === 'countRef') {
                setTimeout(() => {
                    this.$refs[`countRef`].focus();
                }, 200);
            }
            if (type === 'unitSelect') {
                setTimeout(() => {
                    this.$refs[`unitSelect`].focus();
                }, 200);
            }
        },
        // 搜索顾客
        searchCustomer(key) {
            if (![undefined].includes(key)) {
                this.cusForm.Page = 1;
                this.cusForm.stopLoad = false;
                this.cusForm.key = key;
                this.customerList = [];
            }
            if (this.cusForm.stopLoad) return;
            this.loading = true;
            this.$util
                .searchCustomer(this.cusForm.key, this.cusForm.Page, this.cusForm.Limit)
                .then(data => {
                    if (!data) {
                        this.loading = false;
                        return;
                    }
                    this.cusForm.stopLoad = data.length < this.cusForm.Limit;
                    let index = data.findIndex(e => e.EntpCusId == this.submitData.EntpCusId);
                    if (index > -1) {
                        data.splice(index, 1);
                    }

                    this.customerList = [...this.customerList, ...data];
                    this.loading = false;
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        // 客户名称列表，加载更多
        searchCustomLoad() {
            this.cusForm.Page += 1;
            this.searchCustomer();
        },
        // 搜索汽配编码
        searchCode(key, item, index) {
            if (![undefined].includes(key)) {
                this.codeForm.Page = 1;
                this.codeForm.stopLoad = false;
                this.codeForm.key = key;
                this.codeForm.rowIndex = index;
                this.codeList = [];
            }
            if (item) {
                item.APCode = key;
            }
            if (this.codeForm.stopLoad) return;
            this.loading = true;
            this.$util
                .axiosGet({
                    url: '/api/EntpGoods/GetGoodsSelItemsForSaleOrder',
                    data: {
                        APCode: this.codeForm.key,
                        Page: this.codeForm.Page,
                        Limit: this.codeForm.Limit,
                        EntpId: this.userMsg.EntpId,
                        SId: this.submitData.WarehouseId,
                        CId: this.submitData.EntpCusId,
                        OnlySeries: true,
                        SFrom: 'apc'
                    },
                    hideLoading: true
                })
                .then(res => {
                    let that = this;
                    this.loading = false;
                    if (!res.data) {
                        if (this.codeForm.Page == 1 && that.codeForm.key) {
                            let option = this.$refs[`sapcode`].options[0].$el;
                            if (option) {
                                option.onclick = function () {
                                    that.codeChange(that.codeForm.key, that.codeForm.rowIndex);
                                };
                            }
                        }
                        return;
                    }
                    this.codeForm.stopLoad = res.data.length < this.codeForm.Limit;
                    this.codeList = this.$util.uniqueArr(this.codeList, res.data);

                    //ps 入过接口可以按条件的相似度来排序的化，下面的逻辑可以去除，比如查询条件为：1121时
                    that.$nextTick(() => {
                        if (that.codeForm.key) {
                            let hit = res.data.findIndex(c => c.APCode == that.codeForm.key);
                            if (hit != -1) {
                                hit = hit + (that.codeList.length - res.data.length);
                                let option = that.$refs[`sapcode`].options[hit].$el;
                                if (option) {
                                    option.onclick = function () {
                                        that.codeChange(that.codeForm.key, that.codeForm.rowIndex, option);
                                    };
                                }
                            }
                        }
                    });
                });
        },
        // 汽配编码列表，加载更多
        searchCodeLoad() {
            if (!this.loading) {
                this.codeForm.Page += 1;
                this.searchCode();
            }
        },
        // 编码改变
        codeChange(value, index, option) {
            if (option) {
                option.onclick = function () {};
            }
            let _list = this.codeList;
            for (let i = 0; i < _list.length; i++) {
                if (_list[i].EntpTempGoodsId == value) {
                    this.dataList[index].OrderWaitOutQuantity = _list[i].OrderWaitOutQuantity;
                    this.dataList[index].POrderWaitInQuantity = _list[i].POrderWaitInQuantity;

                    this.dataList[index].APCode = _list[i].APCode;
                    this.dataList[index].CostPrice = _list[i].CostPrice;
                    this.dataList[index].EntpTempGoodsId = _list[i].EntpTempGoodsId;
                    this.dataList[index].GoodName = _list[i].GoodName;
                    this.dataList[index].GoodNameItem = _list[i].GoodName;
                    this.dataList[index].GoodName = _list[i].GoodName;
                    this.dataList[index].Unit = _list[i].Unit;
                    this.dataList[index].Origin = _list[i].Origin;
                    this.dataList[index].AutoSerise = _list[i].AutoSerise;
                    this.dataList[index].AutoSeriseItem = _list[i].AutoSerise;
                    this.dataList[index].Inventory = _list[i].Inventory;
                    this.dataList[index].StorageInventory = _list[i].StorageInventory;
                    this.dataList[index].ReferencePrice = _list[i].ReferencePrice;
                    this.dataList[index].LatestSalesTime = _list[i].LatestSalesTime;
                    this.dataList[index].LatestQuoteTime = _list[i].LatestQuoteTime;
                    this.dataList[index].MarketPrice = _list[i].LatestPrice > 0 ? _list[i].LatestPrice : '';
                    this.dataList[index].State = 0;
                    this.dataList[index].BillingPrice = _list[i].MarketPrice == 0 ? '' : _list[i].MarketPrice;
                    this.dataList[index].Size = _list[i].Size;
                    this.dataList[index].Brand = _list[i].Brand;
                    this.$util.getGoodsDataAfterSelItem(this.dataList[index].EntpTempGoodsId, this.submitData.WarehouseId, this.submitData.EntpCusId, '0').then(data => {
                        if (data) {
                            this.dataList[index].OrderWaitOutQuantity = data.OrderWaitOutQuantity;
                            this.dataList[index].POrderWaitInQuantity = data.POrderWaitInQuantity;
                            this.dataList[index].StorageInventory = data.StorageInventory;
                            this.dataList[index].LatestSalesTime = data.LatestSalesTime;
                            this.dataList[index].LatestQuoteTime = data.LatestQuoteTime;

                            this.dataList[index].MarketPrice = data.LatestPrice > 0 ? data.LatestPrice : '';
                            if (data.ReferencePrice) this.dataList[index].ReferencePrice = data.ReferencePrice;
                            this.dataList[index].IntenCount = data.IntenCount;
                        }
                    });
                    break;
                }
            }
            let inputAll = document.querySelectorAll('.salecounts-input-cell .el-input__inner');
            inputAll[0].focus();
            this.priceChange();
        },
        checkCodeRepeat() {
            let repeatIndexs = [];
            let obj = {};
            let _dataList = this.dataList;
            for (let i = 0; i < _dataList.length; i++) {
                _dataList[i].CodeRepeat = false;
                if (!obj[_dataList[i].APCode]) {
                    obj[_dataList[i].APCode] = [i];
                } else {
                    obj[_dataList[i].APCode].push(i);
                }
            }
            for (let key in obj) {
                if (obj[key].length >= 2) {
                    repeatIndexs = [...repeatIndexs, ...obj[key]];
                }
            }
            for (let j = 0; j < repeatIndexs.length; j++) {
                this.dataList[repeatIndexs[j]].CodeRepeat = true;
            }
        },
        //报价历史
        showQuoteHistorie(id) {
            if (id) {
                this.EntpTempGoodsIdEdit = id;
                this.historyQuoteVisible = true;
            }
        },
        closeQuoteHistoryDialog(edit) {
            this.historyVisible = false;
            this.historyQuoteVisible = false;
        },

        //单位下拉框显示时触发event
        unitVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.unitList.length == 0) that.getConfigData();
            }
        },
        //当供应商下拉框出现时触发
        customerVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.customerList.length <= 1) that.searchCustomer('');
            }
        },
        //当汽配件编码下拉框出现时触发
        apCodeVisibleChange(event) {
            let that = this;
            if (event && that.codeList.length == 0 && that.isPreloadApCodeList) {
                that.searchCode('');
            }
        },
        // 设置展示行样式
        setRowStyle(param) {
            const { row, index } = param;
            let rowArr = [];
            if (this.isCheckCode) rowArr = this.dataList.filter(f => f.APCode === row.APCode);
            else rowArr = this.dataList.filter(f => f.EntpTempGoodsId === row.EntpTempGoodsId);
            if (rowArr.length > 1) {
                return `background-color: #FFE8E8`;
            }
        },
        //手动清除单元格激活状态
        clearActived(e) {
            if (e.target.className == 'elx-table--body-wrapper body--wrapper') {
                this.$refs.infiniteTable.clearActived();
            }
            e.stopPropagation();
            e.preventDefault();
        },
        // 设置展示合计数据行
        setSummaries(param) {
            const { data } = param;
            let num = 0;
            let price = 0;
            data.forEach(ele => {
                num += Number(ele.Count);
                price += Number(ele.Count * ele.MarketPrice ? (ele.Count * ele.MarketPrice).toFixed(3) : 0);
            });
            return [['', '', '', '总数量', num, '', '', '合计', price.toFixed(2), '', '']];
        },
        warehouseVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.warehouseList.length <= 1) {
                    that.$util.getWarehouse(1).then(data => {
                        that.warehouseList = data;
                    });
                }
            }
        },
        warehouseChange(val) {
            let that = this;
            if (!val) {
                that.submitData.WarehouseName = '';
                that.dataList.forEach((e, i) => {
                    e.StorageInventory = 0;
                });
            } else {
                for (let i = 0; i < that.warehouseList.length; i++) {
                    if (val == that.warehouseList[i].WarehouseId) {
                        // that.submitData.WarehouseAddr = that.warehouseList[i].Address;
                        that.submitData.WarehouseName = that.warehouseList[i].WarehouseName;
                        break;
                    }
                }

                // 查询在这个仓库下的商品库存
                if (that.dataList) {
                    let ids = [];
                    that.dataList.forEach((e, i) => {
                        if (e.EntpTempGoodsId) ids.push(e.EntpTempGoodsId);
                    });
                    if (ids.length > 0) {
                        that.$util
                            .axiosPost({
                                url: '/api/EntpSaleOrder/GetGoodsStoragesInventorys',
                                data: {
                                    sId: val,
                                    ids: ids
                                }
                            })
                            .then(res => {
                                let data = res.data;
                                that.dataList.forEach((e, i) => {
                                    let getStorage = data.find(d => d.GoodsId == e.EntpTempGoodsId);
                                    if (getStorage) {
                                        e.StorageInventory = getStorage.Count;
                                        e.OrderWaitOutQuantity = getStorage.OrderWaitOutQuantity;
                                        e.POrderWaitInQuantity = getStorage.POrderWaitInQuantity;
                                    } else {
                                        e.StorageInventory = 0;
                                        e.OrderWaitOutQuantity = 0;
                                        e.POrderWaitInQuantity = 0;
                                    }
                                });
                            })
                            .catch(() => {});
                    }
                }
            }
        },
        //获取默认出仓仓库
        getdefaultWarehouses() {
            this.$util
                .axiosGet({
                    url: '/api/EntpQuotationOrder/GetLatestQuotationOrderWarehouse',
                    hideLoading: true
                })
                .then(res => {
                    let defaultWareshouse = res.data;
                    if (defaultWareshouse) {
                        this.warehouseList.push({
                            WarehouseId: defaultWareshouse.WarehouseId,
                            WarehouseName: defaultWareshouse.WarehouseName,
                            Address: defaultWareshouse.Address
                        });
                        this.$set(this.submitData, 'WarehouseId', defaultWareshouse.WarehouseId);
                        this.$set(this.submitData, 'WarehouseName', defaultWareshouse.WarehouseName);
                        this.$set(this.submitData, 'WarehouseAddr', defaultWareshouse.Address);
                        this.warehouseType = defaultWareshouse.WarehouseType;
                    }
                });
        },
        keyEvent(ev, code, row, index) {
            let that = this;
            if (ev.key == 'ArrowLeft') {
                switch (code) {
                    case 'GoodName':
                        that.$refs[`sapcode`].focus();
                        break;
                    case 'AutoSerise':
                        that.$refs[`partsNameSelect`].focus();
                        break;
                    case 'Origin':
                        that.$refs[`autoSeriseSelect`].focus();
                        break;
                    case 'Count':
                        if (that.$refs[`originRef`]) that.$refs[`originRef`].focus();
                        else that.$refs[`partsNameSelect`].focus();
                        break;
                    case 'Unit':
                        if (that.$refs[`unitSelect`]) that.$refs[`unitSelect`].blur();
                        that.$refs[`countRef`].focus();
                        break;
                    case 'MarketPrice':
                        that.$refs[`unitSelect`].focus();
                        break;
                    case 'BillingPrice':
                        that.$refs[`marketPirceRef`].focus();
                        break;
                }
            } else if (ev.key == 'ArrowRight') {
                switch (code) {
                    case 'APCode':
                        if (that.$refs[`sapcode`]) that.$refs[`sapcode`].blur();
                        that.$refs[`partsNameSelect`].focus();
                        break;
                    case 'GoodName':
                        that.$refs[`autoSeriseSelect`].focus();
                        break;
                    case 'AutoSerise':
                        if (that.$refs[`originRef`]) that.$refs[`originRef`].focus();
                        else that.$refs[`countRef`].focus();
                        break;
                    case 'Origin':
                        that.$refs[`countRef`].focus();
                        break;
                    case 'Count':
                        that.$refs[`unitSelect`].focus();
                        break;
                    case 'Unit':
                        if (that.$refs[`unitSelect`]) that.$refs[`unitSelect`].blur();
                        that.$refs[`marketPirceRef`].focus();
                        break;
                    case 'MarketPrice':
                        if (that.$refs[`billingPriceRef`]) that.$refs[`billingPriceRef`].focus();
                        break;
                }
            }
        },
        getSetsData() {
            this.$util.getTableSetsData(this.tableCode, true).then(data => {
                data.forEach(item => {
                    switch (item.ColumnCode) {
                        case 'APCode':
                            this.columnShowSets.APCode.IsShow = item.IsShow;
                            this.columnShowSets.APCode.Width = item.Width;
                            this.columnShowSets.APCode.ColumnName = item.ColumnName;
                            break;
                        case 'GoodCode':
                            this.columnShowSets.GoodCode.IsShow = item.IsShow;
                            this.columnShowSets.GoodCode.Width = item.Width;
                            this.columnShowSets.GoodCode.ColumnName = item.ColumnName;
                            break;
                        case 'GoodName':
                            this.columnShowSets.GoodName.IsShow = item.IsShow;
                            this.columnShowSets.GoodName.Width = item.Width;
                            this.columnShowSets.GoodName.ColumnName = item.ColumnName;
                            break;
                        case 'AutoSerise':
                            this.columnShowSets.AutoSerise.IsShow = item.IsShow;
                            this.columnShowSets.AutoSerise.Width = item.Width;
                            this.columnShowSets.AutoSerise.ColumnName = item.ColumnName;
                            break;
                        case 'GeneralModels':
                            this.columnShowSets.GeneralModels.IsShow = item.IsShow;
                            this.columnShowSets.GeneralModels.Width = item.Width;
                            this.columnShowSets.GeneralModels.ColumnName = item.ColumnName;
                            break;
                        case 'CostPrice':
                            this.columnShowSets.CostPrice.IsShow = item.IsShow;
                            this.columnShowSets.CostPrice.Width = item.Width;
                            this.columnShowSets.CostPrice.ColumnName = item.ColumnName;
                            break;
                        case 'Price':
                            this.columnShowSets.Price.IsShow = item.IsShow;
                            this.columnShowSets.Price.Width = item.Width;
                            this.columnShowSets.Price.ColumnName = item.ColumnName;
                            break;
                        case 'MarketPrice':
                            this.columnShowSets.MarketPrice.IsShow = item.IsShow;
                            this.columnShowSets.MarketPrice.Width = item.Width;
                            this.columnShowSets.MarketPrice.ColumnName = item.ColumnName;
                            break;
                        case 'Inventory':
                            this.columnShowSets.Inventory.IsShow = item.IsShow;
                            this.columnShowSets.Inventory.Width = item.Width;
                            this.columnShowSets.Inventory.ColumnName = item.ColumnName;
                            break;
                        case 'Remaining':
                            this.columnShowSets.Remaining.IsShow = item.IsShow;
                            this.columnShowSets.Remaining.Width = item.Width;
                            this.columnShowSets.Remaining.ColumnName = item.ColumnName;
                            break;
                        case 'OrderWaitOutQuantity':
                            this.columnShowSets.OrderWaitOutQuantity.IsShow = item.IsShow;
                            this.columnShowSets.OrderWaitOutQuantity.Width = item.Width;
                            this.columnShowSets.OrderWaitOutQuantity.ColumnName = item.ColumnName;
                            break;
                        case 'POrderWaitInQuantity':
                            this.columnShowSets.POrderWaitInQuantity.IsShow = item.IsShow;
                            this.columnShowSets.POrderWaitInQuantity.Width = item.Width;
                            this.columnShowSets.POrderWaitInQuantity.ColumnName = item.ColumnName;
                            break;
                        case 'UpperLimit':
                            this.columnShowSets.UpperLimit.IsShow = item.IsShow;
                            this.columnShowSets.UpperLimit.Width = item.Width;
                            this.columnShowSets.UpperLimit.ColumnName = item.ColumnName;
                            break;
                        case 'LowerLimit':
                            this.columnShowSets.LowerLimit.IsShow = item.IsShow;
                            this.columnShowSets.LowerLimit.Width = item.Width;
                            this.columnShowSets.LowerLimit.ColumnName = item.ColumnName;
                            break;
                        case 'Unit':
                            this.columnShowSets.Unit.IsShow = item.IsShow;
                            this.columnShowSets.Unit.Width = item.Width;
                            this.columnShowSets.Unit.ColumnName = item.ColumnName;
                            break;
                        case 'Cate':
                            this.columnShowSets.Cate.IsShow = item.IsShow;
                            this.columnShowSets.Cate.Width = item.Width;
                            this.columnShowSets.Cate.ColumnName = item.ColumnName;
                            break;
                        case 'Brand':
                            this.columnShowSets.Brand.IsShow = item.IsShow;
                            this.columnShowSets.Brand.Width = item.Width;
                            this.columnShowSets.Brand.ColumnName = item.ColumnName;
                            break;
                        case 'Origin':
                            this.columnShowSets.Origin.IsShow = item.IsShow;
                            this.columnShowSets.Origin.Width = item.Width;
                            this.columnShowSets.Origin.ColumnName = item.ColumnName;
                            break;
                        case 'Quality':
                            this.columnShowSets.Quality.IsShow = item.IsShow;
                            this.columnShowSets.Quality.Width = item.Width;
                            this.columnShowSets.Quality.ColumnName = item.ColumnName;
                            break;
                        case 'Size':
                            this.columnShowSets.Size.IsShow = item.IsShow;
                            this.columnShowSets.Size.Width = item.Width;
                            this.columnShowSets.Size.ColumnName = item.ColumnName;
                            break;
                        case 'Size2':
                            this.columnShowSets.Size2.IsShow = item.IsShow;
                            this.columnShowSets.Size2.Width = item.Width;
                            this.columnShowSets.Size2.ColumnName = item.ColumnName;
                            break;
                        case 'Texture':
                            this.columnShowSets.Texture.IsShow = item.IsShow;
                            this.columnShowSets.Texture.Width = item.Width;
                            this.columnShowSets.Texture.ColumnName = item.ColumnName;
                            break;
                        case 'Color':
                            this.columnShowSets.Color.IsShow = item.IsShow;
                            this.columnShowSets.Color.Width = item.Width;
                            this.columnShowSets.Color.ColumnName = item.ColumnName;
                            break;
                        case 'GoodDesc':
                            this.columnShowSets.GoodDesc.IsShow = item.IsShow;
                            this.columnShowSets.GoodDesc.Width = item.Width;
                            this.columnShowSets.GoodDesc.ColumnName = item.ColumnName;
                            break;
                        case 'UpdateTime':
                            this.columnShowSets.UpdateTime.IsShow = item.IsShow;
                            this.columnShowSets.UpdateTime.Width = item.Width;
                            this.columnShowSets.UpdateTime.ColumnName = item.ColumnName;
                            break;
                        case 'CreateTime':
                            this.columnShowSets.CreateTime.IsShow = item.IsShow;
                            this.columnShowSets.CreateTime.Width = item.Width;
                            this.columnShowSets.CreateTime.ColumnName = item.ColumnName;
                            break;
                        case 'PlanPurchase':
                            this.columnShowSets.PlanPurchase.IsShow = item.IsShow;
                            this.columnShowSets.PlanPurchase.Width = item.Width;
                            this.columnShowSets.PlanPurchase.ColumnName = item.ColumnName;
                            break;
                        case 'IntenCount':
                            this.columnShowSets.IntenCount.IsShow = item.IsShow;
                            this.columnShowSets.IntenCount.Width = item.Width;
                            this.columnShowSets.IntenCount.ColumnName = item.ColumnName;
                            break;
                    }
                });
            });
        },
        getJointSearchSets() {
            this.$util.getJointSearchSetsData(true).then(data => {
                data.forEach(item => {
                    if (item.IsSeparator) {
                        this.separator = item.Separator;
                        return;
                    }
                });
            });
        },
        /**
         * 表格滚动
         * 只有在滚动到底部，并且下方还有数据的情况下刷新
         */
        tableLoad({ scrollTop, scrollLeft }, event) {
            var t = event.currentTarget.scrollTop; // 表格内容已滚动的高度
            var s = event.currentTarget.scrollHeight; // 表格内容撑起的高度
            var c = event.currentTarget.clientHeight; // 表格视窗高度 即wraper
            if (scrollTop > this.scrollTop && !this.stopFresh && t + c >= s - 50) {
                //第一页还没有数据就去请求第二页，想太多了吧`(*>﹏<*)′
                if (this.tableData && this.tableData.length > 0) {
                    this.searchData.page += 1;
                    if (scrollTop !== 0) this.scrollTop = scrollTop;
                    this.scrollLeft = scrollLeft;
                } else {
                    this.searchData.page = 1;
                    this.scrollTop = 0;
                    this.scrollLeft = 0;
                }
                this.getAPTableData();
            }
        },
        downKeyToLoad() {
            if (this.tableData && this.tableData.length > 0) {
                this.searchData.page += 1;
            } else {
                this.searchData.page = 1;
            }
            this.getAPTableData();
        },
        getAPTableData() {
            if (this.searchData.Symbol) {
                if (this.searchData.Symbol == 'between') {
                    if (isNaN(this.searchData.Invent1)) {
                        this.$util.warningMsg('请输入正确的库存数');
                        return;
                    }
                    if (isNaN(this.searchData.Invent2)) {
                        this.$util.warningMsg('请输入正确的库存数');
                        return;
                    }
                } else {
                    if (isNaN(this.searchData.Invent1)) {
                        this.$util.warningMsg('请输入正确的库存数');
                        return;
                    }
                }
            } else {
                if (!this.searchData.Invent1) this.searchData.Invent1 = 0;
                if (!this.searchData.Invent2) this.searchData.Invent2 = 0;
            }

            if (this.isBrandSort && !this.searchData.SortProp) {
                this.searchData.SortProp = 'Brand';
                this.searchData.SortType = 'descending';
            } else if (this.isOriginSort && !this.searchData.SortProp) {
                this.searchData.SortProp = 'Origin';
                this.searchData.SortType = 'descending';
            }

            this.searchData.CId = this.submitData.EntpCusId;
            this.searchData.SId = this.submitData.WarehouseId;
            if (this.SelectedData && this.SelectedData.length > 0) {
                this.searchData.SelectedData = this.SelectedData;
            }
            if (this.searchData.page == 1) {
                this.searchParams = {
                    ...this.searchData
                };
            } else {
                this.searchParams.page = this.searchData.page;
            }
            this.searchLoading = true;
            this.stopFresh = true;

            let url = '';
            if (this.isUseSE) url = '/api/EntpGoods/GetGoodsListFromSE';
            else url = '/api/EntpGoods/GetGoodsListForEditOrder_V3';

            this.$util
                .axiosPost({
                    url: url,
                    data: this.searchParams,
                    hideLoading: true
                })
                .then(res => {
                    let data = res.data;
                    this.tableDataLength = res.count;
                    if (!data) {
                        if (this.searchData.page == 1) this.tableData = [];
                        return;
                    }

                    for (let i = 0; i < data.length; i++) {
                        data[i].LoadSpaceInvent = true;
                    }

                    let list = [...this.tableData, ...data];
                    const maps = new Map();
                    list = list.filter(m => !maps.has(m.EntpTempGoodsId) && maps.set(m.EntpTempGoodsId, 1));
                    //因为接口的原因，返回前后两页数据有重复，所以在这里做去重
                    this.tableData = list;

                    if (this.dataList.length > 0) {
                        this.tableData.forEach(goods => {
                            let idx = this.dataList.findIndex(f => f.EntpTempGoodsId == goods.EntpTempGoodsId);
                            if (idx > -1) {
                                goods.IsSelected = true;
                            }
                        });
                    }
                    this.stopFresh = data.length < this.searchData.limit;

                    if (
                        this.columnShowSets.OrderWaitOutQuantity.IsShow ||
                        this.columnShowSets.POrderWaitInQuantity.IsShow ||
                        this.columnShowSets.PlanPurchase.IsShow ||
                        this.columnShowSets.IntenCount.IsShow
                    )
                        this.getOtherData(data);
                })
                .catch(e => {})
                .finally(() => {
                    this.searchLoading = false;
                });
        },
        async getOtherData(data) {
            let that = this;
            if (data && data.length > 0) {
                for (let i = 0; i < data.length; i++) {
                    that.loopGetData(data[i].EntpTempGoodsId);
                    await that.$util.sleep(150);
                }
            }
        },
        loopGetData(id) {
            let that = this;
            let url = '';
            if (that.isUseSE) url = '/api/EntpGoods/GetAfteSearchPartForSE';
            else url = '/api/EntpGoods/GetAfteSearchPartData_V3';
            that.$util
                .axiosGet({
                    // url: '/api/EntpGoods/GetAfteSearchPartData_V3',
                    url: url,
                    data: {
                        goodsId: id,
                        sId: this.searchData.SId,
                        isShowPlanPur: that.columnShowSets.PlanPurchase.IsShow,
                        isShowOrderWaitOut: that.columnShowSets.OrderWaitOutQuantity.IsShow,
                        isShowPOrderWaitIn: that.columnShowSets.POrderWaitInQuantity.IsShow,
                        isShowInven: that.columnShowSets.IntenCount.IsShow
                    },
                    hideLoading: true
                })
                .then(res => {
                    let data = res.data;
                    if (!data) {
                        return;
                    }
                    that.tableData.forEach(item => {
                        if (item.EntpTempGoodsId == data.GoodsId) {
                            item.LoadSpaceInvent = false;
                            item.OrderWaitOutQuantity = data.OrderWaitOutQuantity;
                            item.POrderWaitInQuantity = data.POrderWaitInQuantity;
                            item.IntenCount = data.IntenCount;
                            item.PlanPurchase = data.PlanPurchase;
                            if (that.isUseSE) {
                                item.Inventory = data.StorageInventory;
                                item.StorageInventory = data.StorageInventory;
                            }
                            if (!that.submitData.WarehouseId) {
                                item.Inventory = data.StorageInventory;
                                item.StorageInventory = data.StorageInventory;
                            }
                            return;
                        }
                    });
                })
                .catch(() => {});
        },
        showTableSetDialog() {
            this.tableSetsVisible = true;
        },
        onDateTimeSelect(val) {
            if (val != null) {
                this.searchData.InStartDate = val[0];
                this.searchData.InEndDate = val[1];
            } else {
                this.searchData.InStartDate = '';
                this.searchData.InEndDate = '';
            }
        },
        resetSearch() {
            this.searchData = {
                APCode: '',
                GoodCode: '',
                GoodName: '',
                GoodDesc: '',
                AutoSerise: '',
                Brand: '',
                BrandName: [],
                Size: '',
                Cate: [],
                page: 1,
                limit: 15,
                CId: '',
                SId: '',
                SortProp: '',
                SortType: '',
                Source: '0',
                JointSearch: '',
                Symbol: '',
                Invent1: 0,
                Invent2: 0,
                Origin: '',
                SearchType: 2
            };
            this.datetime = [];
            this.isSearch = false;
        },
        handleSearch() {
            let that = this;
            that.searchData.page = 1;
            that.dataindex = -1;
            that.tableData = [];
            that.isSearch = true;
            that.scrollTop = 0;

            if (!that.searchLoading) {
                that.getAPTableData();
            }
            if (that.searchVisible) {
                that.searchVisible = false;
                that.isStartSearch = false;
            }
        },
        searchGoodName(key, cb) {
            if (![undefined].includes(key)) {
                this.goodNameForm.Page = 1;
                this.goodNameForm.stopLoad = false;
                this.goodNameForm.key = key;
                this.goodNameOptions = [];
            }
            if (cb) {
                this.nameCallBack = cb;
            }
            if (this.goodNameForm.stopLoad) return;
            this.optionLoading = true;
            this.$util.searchPartAttr(this.goodNameForm.key, 1, this.goodNameForm.Page, this.goodNameForm.Limit).then(data => {
                this.optionLoading = false;
                let arr = [];
                if (data) {
                    this.goodNameForm.stopLoad = data.length < this.goodNameForm.Limit;
                    data.forEach(e => {
                        arr.push({ value: e });
                    });
                }
                this.goodNameOptions = [...this.goodNameOptions, ...arr];
                if (this.nameCallBack) {
                    this.nameCallBack(this.goodNameOptions);
                }
            });
        },
        searchGoodNameLoad() {
            this.goodNameForm.Page += 1;
            this.searchGoodName();
        },
        searchAutoSerise(key, cb) {
            if (![undefined].includes(key)) {
                this.autoSeriseForm.Page = 1;
                this.autoSeriseForm.stopLoad = false;
                this.autoSeriseForm.key = key;
                this.autoSeriseOptions = [];
            }
            if (cb) {
                this.autoCallBack = cb;
            }
            if (this.autoSeriseForm.stopLoad) return;
            this.$util.searchPartAttr(this.autoSeriseForm.key, 2, this.autoSeriseForm.Page, this.autoSeriseForm.Limit).then(data => {
                let arr = [];
                if (data) {
                    this.autoSeriseForm.stopLoad = data.length < this.autoSeriseForm.Limit;
                    data.forEach(e => {
                        arr.push({ value: e });
                    });
                }
                this.autoSeriseOptions = [...this.autoSeriseOptions, ...arr];
                if (this.autoCallBack) {
                    this.autoCallBack(this.autoSeriseOptions);
                }
            });
        },
        searchAutoSeriseLoad() {
            this.autoSeriseForm.Page += 1;
            this.searchAutoSerise();
        },
        stopSearch() {
            this.canSearch = false;
        },
        closeViewer() {
            this.showViewer = false;
            this.$message.closeAll();
        },
        async getGoodsImages() {
            if (this.currentRow) {
                if (!this.srcList || this.srcList.length == 0) {
                    const { data } = await this.$util.axiosGet({
                        url: '/api/EntpGoods/GetGoodsImages',
                        data: { goodsId: this.currentRow.EntpTempGoodsId }
                    });
                    if (data) {
                        this.srcList = data;
                    }
                }
                this.showViewer = true;
                this.$message({
                    message: this.currentRow.APCode,
                    center: true,
                    duration: 0,
                    customClass: 'apcode_msgCls'
                });
            }
        },
        refreshResult() {
            this.searchData.page = 1;
            this.handleSearch();
        }
    }
};
</script>
<style lang="less" scoped>
.invens-summary {
    display: flex;
    flex-direction: row;
    height: 40px;
    line-height: 30px;
    padding: 0 20px;
    font-size: 14px;
    margin-left: -1px;
    border: 1px solid rgb(226, 226, 226);
    align-items: center;
    overflow-x: auto;
    overflow-y: hidden;
    white-space: nowrap;

    .title {
        font-size: 16px;
        font-weight: 600;
    }
    .summary-item {
        display: flex;
        flex-direction: row;

        .sname {
            font-size: 18px;
        }

        .scount {
            font-size: 20px;
            font-weight: 700px;
            color: #ea7060;
            margin-right: 20px;
        }
    }
}
.el-row {
    margin-bottom: 10px;

    &:last-child {
        margin-bottom: 10px;
    }
}
.section-title {
    display: flex;
    justify-content: space-between;
    height: 32px;
    line-height: 32px;
    padding: 0 20px;
    font-weight: bold;
    font-size: @font-sm;
    margin-left: -1px;
    background: @border3Color;
    position: relative;
}
.edit-ctn {
    .div-table-cell {
        padding: 0 5px;
    }
}
.option-content {
    display: flex;
    line-height: 30px;

    .project-Name {
        width: 200px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        margin-right: 12px;
    }

    .project-iven {
        width: 50px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
}
.btn-ctn {
    padding: 30px 0;
    margin-right: 110px;
    text-align: right;
    padding-bottom: 240px;
}
.add-btn {
    position: absolute;
    right: -40px;
    bottom: -40px;
}
.less-btn {
    position: absolute;
    right: -40px;
    top: 4px;
    z-index: 2;
}
.table-main {
    position: relative;
}
.image-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 60px;
    height: 60px;
    border: 1px dashed @border3Color;
}
.table-title {
    line-height: 36px;
    text-align: center;
    font-weight: bold;
}
.div-table-cell {
    display: flex;
    align-items: center;
    justify-content: center;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
}
.table-item {
    height: 50px;
    position: relative;
}
.div-table-row {
    overflow: inherit;
    margin-left: 0;
}
.div-table-cell-code {
    position: relative;
    .row-delete {
        position: absolute;
        padding: 1px 6px;
        top: 0;
        right: 0;
        color: #fff;
        background: #ffcc66;
        border-radius: 12.5px;
    }
}

.saveProgress {
    position: absolute;
    top: 38%;
    left: 45%;
    z-index: 99999;
}
.section-magin {
    margin-bottom: 5px;
}
.img-e-op {
    height: 32px;
    width: 32px;

    img {
        height: 28px;
        width: 28px;
        margin-bottom: 2px;
    }
}
.special-border {
    height: 100%;
    border-radius: 3px;
    border: 1px solid #ffcc00;
}
.wNameTip {
    display: inline-block;
    position: absolute;
    right: 90px;
    top: 0px;

    i {
        font-weight: 500;
    }
}
.head-view {
    display: flex;
    justify-content: flex-start;
    align-items: center;

    .color-red {
        margin-right: 4px;
    }

    .sort-view {
        display: flex;
        flex-direction: column;

        i {
            line-height: 8px;
            cursor: pointer;
        }

        .active {
            color: #409eff;
        }
    }
}
#search-dc-dialog,
#comfirm-ap-dialog {
    position: absolute;
    top: 0;
    left: 50%;
    right: auto;
    bottom: auto;
    width: 10px;
    height: 10px;
    overflow: visible;

    .el-dialog {
        box-shadow: 0 0 9px 3px #999;
    }

    .search-item-dialog {
        width: 340px;
        height: auto;

        .dialog-footer {
            text-align: right;
        }

        .el-form-item {
            margin-bottom: 0;
        }
    }

    .el-dialog__body {
        height: calc(100% - 54px);
        overflow: auto;
    }
}

#ap-image-dialog {
    position: absolute;
    top: auto;
    left: 0;
    right: auto;
    bottom: 400px;
    width: 10px;
    height: 10px;
    overflow: visible;

    .el-dialog {
        box-shadow: 0 0 9px 3px #999;
    }

    .image-item-dialog {
        width: 120px;
        height: 120px;
    }

    .el-dialog__body {
        padding: 0 !important;
        overflow: auto;
    }
}

.search-set-btn {
    margin-top: 4px;
    height: 24px;
    width: 25px;
    line-height: 24px;
    padding: 0;
    margin-right: 5px;
    margin-left: 2px;
}
</style>
<style lang="less">
.quotation-order-infoes {
    border: 1px solid @border3Color;
    padding-top: 10px;
    margin-bottom: 10px;

    .grid-content {
        border-radius: 4px;
        min-height: 32px;
    }
    .el-form-item {
        margin-bottom: 0px;
        line-height: 32px;
        height: 32px;
    }

    .el-form-item__label {
        line-height: 32px;
        height: 32px;
    }

    .el-form-item__content {
        line-height: 32px !important;
        height: 32px;
        top: -1px;
    }
}
#search-dialog {
    .el-dialog {
        box-shadow: 0 0 9px 3px #999;
    }
    .el-dialog__body {
        overflow: auto;
    }
}
#search-dialog::-webkit-scrollbar {
    display: none;
}
.check-code-class {
    .el-input__inner {
        border: 1px solid #f56c6c;
    }
}
.bj-edit {
    padding: 10px 20px 0px 20px;
}
.search-in-order {
    .elx-table {
        .elx-body--row.row--hover,
        .elx-body--row.row--hover.row--stripe {
            background-color: #dcdee1;
        }

        .elx-table--header-wrapper {
            .elx-header--row {
                .elx-header--column {
                    height: 34px;
                }

                .elx-cell {
                    padding: 4px 12px 0;
                }
            }
        }

        .elx-table--body-wrapper {
            .elx-body--row {
                .table-sort {
                    .elx-cell {
                        padding: 4px 12px 0;
                    }
                }

                td {
                    height: 26px;
                    line-height: 26px;
                }
            }

            .elx-cell {
                height: 26px;
            }
        }

        .elx-table--footer-wrapper {
            margin-top: 0 !important;
        }
    }
}
.sales-order-edit {
    .elx-table {
        .elx-body--row.row--hover,
        .elx-body--row.row--hover.row--stripe {
            background-color: #dcdee1;
        }

        .elx-table--header-wrapper {
            .elx-header--row {
                .elx-header--column {
                    height: 34px;
                }

                .elx-cell {
                    padding: 4px 12px 0;
                }
            }
        }

        .elx-table--body-wrapper {
            .elx-body--row {
                .table-sort {
                    .elx-cell {
                        padding: 4px 12px 0;
                    }
                }

                .div-padding-12 {
                    padding: 4px 8px 0;
                }

                .div-margin-op {
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                }

                .operate {
                    padding: 0 12px;
                }

                td {
                    height: 26px;
                }
            }

            .elx-cell {
                padding: 0;
                height: 32px;
            }

            .el-button--small {
                padding: 5px 15px;
                margin: 3px 9px 0 0;
            }
        }

        .elx-table--footer-wrapper {
            margin-top: 0 !important;
        }

        .elx-table--body-wrapper {
            padding-bottom: 180px !important;
        }
    }

    .sales-input-cell {
        .el-input-number {
            width: 100%;
        }

        .el-input {
            .el-input__inner {
                padding-left: 0;
                padding-right: 20px;
            }
        }

        .el-input-number__decrease,
        .el-input-number__increase {
            width: 20px;
        }
    }

    .salecounts-input-cell {
        .el-input-number {
            width: 100%;
        }

        .el-input {
            .el-input__inner {
                padding-left: 0;
                padding-right: 20px;
            }
        }

        .el-input-number__decrease,
        .el-input-number__increase {
            width: 20px;
        }
    }

    .unit-input-cell {
        .el-input {
            .el-input__inner {
                padding-right: 20px;
            }
        }
    }

    .sales-apcode {
        .el-tag {
            height: 24px;
            line-height: 22px;
            margin-left: 8px;
        }

        .sp-i {
            height: 24px;
            margin-left: -6px;
            margin-right: 2px;
        }
        .el-icon-info {
            color: #87a7d6;
            font-size: 18px;
            vertical-align: top;
            cursor: pointer;
            margin-top: 2px;
        }
    }
}
</style>
